import { ControlContainer, NgModelGroup, FormGroupName, NgControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Component, Input, ViewChild, Directive, ViewContainerRef, Injectable, EventEmitter, ComponentFactoryResolver, Renderer2, ElementRef, Output, SkipSelf, Optional, ChangeDetectorRef, HostListener, Version, NgModule } from '@angular/core';
import { __values, __extends } from 'tslib';
import { BehaviorSubject, Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * BFM Error Class to be used when passing error information in between components
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/forms';

var _c0 = ["bfmDefaultErrorTemplate"];
function BfmErrorComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BfmErrorComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var error_r3 = ctx.error;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(error_r3.message);
} }
var _c1 = function (a0) { return { error: a0 }; };
function BfmErrorContainerComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BfmErrorContainerComponent_ng_template_2_bfm_error_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bfm-error", 4);
} if (rf & 2) {
    var e_r4 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("error", e_r4);
} }
function BfmErrorContainerComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, BfmErrorContainerComponent_ng_template_2_bfm_error_0_Template, 1, 1, "bfm-error", 3);
} if (rf & 2) {
    var ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.errors);
} }
var _c2 = function (a0) { return { errors: a0 }; };
var /**
 * BFM Error Class to be used when passing error information in between components
 */
BfmError = /** @class */ (function () {
    /**
     * @param message
     * @param id
     * @param userData
     * @param templateRef
     * @param bfmComponentRef
     */
    function BfmError(message, formElementId, id, errorElementIndex, elementName, userData, templateRef, bfmComponentRef) {
        if (userData === void 0) { userData = {}; }
        this.message = message;
        this.formElementId = formElementId;
        this.elementId = id;
        this.errorElementIndex = errorElementIndex;
        this.elementName = elementName;
        this.userData = userData;
        this.templateRef = templateRef;
        this.bfmComponentRef = bfmComponentRef;
    }
    /**
     *
     * @param eo Error object to be compared with
     * Compare 2 BfmError objects.
     * As of now compare only the members of basic types. In future, if required,
     * object comparision can be added.
     */
    /**
     *
     * @param {?} eo Error object to be compared with
     * Compare 2 BfmError objects.
     * As of now compare only the members of basic types. In future, if required,
     * object comparision can be added.
     * @return {?}
     */
    BfmError.prototype.isErrorObjectSame = /**
     *
     * @param {?} eo Error object to be compared with
     * Compare 2 BfmError objects.
     * As of now compare only the members of basic types. In future, if required,
     * object comparision can be added.
     * @return {?}
     */
    function (eo) {
        var /** @type {?} */ same = false;
        same = (this.message === eo.message);
        same = same && (this.formElementId === eo.formElementId);
        same = same && (this.elementId === eo.elementId);
        same = same && (this.errorElementIndex === eo.errorElementIndex);
        same = same && (this.elementName === eo.elementName);
        return same;
    };
    return BfmError;
}());
function BfmError_tsickle_Closure_declarations() {
    /**
     * Error message that needs to be shown to the user
     * @type {?}
     */
    BfmError.prototype.message;
    /**
     * Identifies the element that provides an error message
     * @type {?}
     */
    BfmError.prototype.elementId;
    /**
     * Identifies the element that provides an error message
     * @type {?}
     */
    BfmError.prototype.formElementId;
    /**
     * Name of the form field - either value of bfmLabel or name/formControlName attribute
     * value
     * @type {?}
     */
    BfmError.prototype.elementName;
    /**
     * User specific data, if any
     * @type {?}
     */
    BfmError.prototype.userData;
    /**
     * Error template within the container. If provided, this template will
     * be overridden the default BFM error template
     * @type {?}
     */
    BfmError.prototype.templateRef;
    /**
     * Component that generated this error - form, group or field
     * @type {?}
     */
    BfmError.prototype.bfmComponentRef;
    /**
     * Index of the error element in the same order as it the form fields
     * are rendered
     * @type {?}
     */
    BfmError.prototype.errorElementIndex;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * BFM Error component to handle input errors individually. This error component
 * will show up when a field is invalid.
 *
 * #### The following CSS classes can be overridden to customize UI
 *
 * `.bfm-invalid`
 *
 * To override the error field.<br>
 * _Default_: Field highlighted with red border (border color: `#dc0a0a`)
 *
 * `.bfm-error-message`
 *
 * To override the style of error message.<br>
 * _Default_: Error message preceded with an icon (color: `#dc0a0a`)
 *
 * `.bfmfield-errorindicator`
 *
 * Applied for padding the absolutely positioned icon.<br>
 * _Default_: Padding towards right
 *
 * `i.icon-error-message`
 *
 * To override the style of error indicator.<br>
 * _Default_: Exclamation icon toward the right side of the field (color: `#dc0a0a`)
 *
 */
var BfmErrorComponent = /** @class */ (function () {
    function BfmErrorComponent() {
    }
    /** @nocollapse */
    BfmErrorComponent.propDecorators = {
        "error": [{ type: Input },],
        "bfmDefaultErrorTemplate": [{ type: ViewChild, args: ['bfmDefaultErrorTemplate', { static: false },] },],
    };
BfmErrorComponent.ɵfac = function BfmErrorComponent_Factory(t) { return new (t || BfmErrorComponent)(); };
BfmErrorComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BfmErrorComponent, selectors: [["bfm-error"]], viewQuery: function BfmErrorComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.bfmDefaultErrorTemplate = _t.first);
    } }, inputs: { error: "error" }, decls: 4, vars: 4, consts: [[1, "bfm-error-message"], [4, "bfmRender", "bfmRenderContext"], ["defaultErrorTemplate", ""]], template: function BfmErrorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, BfmErrorComponent_ng_container_1_Template, 1, 0, "ng-container", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(2, BfmErrorComponent_ng_template_2_Template, 2, 1, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        var _r1 = ɵngcc0.ɵɵreference(3);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("bfmRender", ctx.error.templateRef || _r1)("bfmRenderContext", ɵngcc0.ɵɵpureFunction1(2, _c1, ctx.error));
    } }, directives: function () { return [BfmErrorRenderDirective]; }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BfmErrorComponent, [{
        type: Component,
        args: [{
                selector: 'bfm-error',
                template: "<div class=\"bfm-error-message\">\n  <ng-container *bfmRender=\"error.templateRef || defaultErrorTemplate; context:{error:error}\"></ng-container>\n</div>\n\n<ng-template #defaultErrorTemplate let-error=\"error\"><span>{{ error.message }}</span></ng-template>\n"
            }]
    }], function () { return []; }, { error: [{
            type: Input
        }], bfmDefaultErrorTemplate: [{
            type: ViewChild,
            args: ['bfmDefaultErrorTemplate', { static: false }]
        }] }); })();
    return BfmErrorComponent;
}());
function BfmErrorComponent_tsickle_Closure_declarations() {
    /** @type {!Array<{type: !Function, args: (undefined|!Array<?>)}>} */
    BfmErrorComponent.decorators;
    /**
     * @nocollapse
     * @type {function(): !Array<(null|{type: ?, decorators: (undefined|!Array<{type: !Function, args: (undefined|!Array<?>)}>)})>}
     */
    BfmErrorComponent.ctorParameters;
    /** @type {!Object<string,!Array<{type: !Function, args: (undefined|!Array<?>)}>>} */
    BfmErrorComponent.propDecorators;
    /**
     * Error object that will be shown to the user
     * @type {?}
     */
    BfmErrorComponent.prototype.error;
    /**
     * Default error template provided by BFM. This default template can be
     * overridden by supplying `TemplateRef` in the error object (`BfmError`)
     * @type {?}
     */
    BfmErrorComponent.prototype.bfmDefaultErrorTemplate;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * BFM Error Container component contains all errors and will be responsible for
 * error addition, removal, consolidation process.
 *
 * The following CSS classes can be overridden to customize UI
 *
 * `.bento-error-summary-container`
 *
 * To override the style of error summary container, used in **_Accessible
 * Sign-up Form_** demo<br> _Default_: see usage in demo
 *
 */
var BfmErrorContainerComponent = /** @class */ (function () {
    function BfmErrorContainerComponent() {
        this.errorMap = {};
    }
    /**
     * Set error container template to override the default error container
     * template
     * @param containerTemplate Error Container template
     */
    /**
     * Set error container template to override the default error container
     * template
     * @param {?} containerTemplate Error Container template
     * @return {?}
     */
    BfmErrorContainerComponent.prototype.setErrorContainerTemplate = /**
     * Set error container template to override the default error container
     * template
     * @param {?} containerTemplate Error Container template
     * @return {?}
     */
    function (containerTemplate) {
        this.errorContainerTemplate = containerTemplate;
    };
    /**
     * Add error object to the list. Smartly insert the error in the order it's
     * created
     * @param e Error to be added to the list
     */
    /**
     * Add error object to the list. Smartly insert the error in the order it's
     * created
     * @param {?} e Error to be added to the list
     * @return {?}
     */
    BfmErrorContainerComponent.prototype.addError = /**
     * Add error object to the list. Smartly insert the error in the order it's
     * created
     * @param {?} e Error to be added to the list
     * @return {?}
     */
    function (e) {
        if (this.addToErrorMap(e) <= 1) {
            if (!this.errors.length) {
                // first error, just push it to the list
                this.errors.push(e);
            }
            else if (e.errorElementIndex < this.errors[0].errorElementIndex) {
                // stick it in the front
                this.errors.unshift(e);
            }
            else if (e.errorElementIndex >
                this.errors[this.errors.length - 1].errorElementIndex) {
                // push it last
                this.errors.push(e);
            }
            else {
                var /** @type {?} */ length_1 = this.errors.length;
                for (var /** @type {?} */ i = 1; i < length_1; i++) {
                    if (e.errorElementIndex < this.errors[i].errorElementIndex) {
                        // stick in at position i
                        this.errors.splice(i, 0, e);
                        break;
                    }
                }
            }
        }
    };
    /**
     * Remove error from the list.
     * @param e Error to be removed from the list
     */
    /**
     * Remove error from the list.
     * @param {?} e Error to be removed from the list
     * @return {?}
     */
    BfmErrorContainerComponent.prototype.removeError = /**
     * Remove error from the list.
     * @param {?} e Error to be removed from the list
     * @return {?}
     */
    function (e) {
        var /** @type {?} */ errorToRemove;
        var /** @type {?} */ count = this.removeFromErrorMap(e);
        // still there are some errors, clear it all
        if (count >= 0) {
            var /** @type {?} */ nextError = this.getNextErrorIdFromErrorMap(e);
            var /** @type {?} */ index = this.findErrorIndex(this.errors, e);
            if (index > -1) {
                if (nextError) {
                    errorToRemove = this.errors.splice(index, 1, nextError)[0];
                }
                else {
                    errorToRemove = this.errors.splice(index, 1)[0];
                }
            }
        }
        return errorToRemove;
    };
    /**
     * Reuse the same bfm-error tag
     * @param error Current Error message that is being shown
     * @param newErrorMessage New error message that must be shown
     */
    /**
     * Reuse the same bfm-error tag
     * @param {?} error Current Error message that is being shown
     * @param {?} newErrorMessage New error message that must be shown
     * @return {?}
     */
    BfmErrorContainerComponent.prototype.modifyError = /**
     * Reuse the same bfm-error tag
     * @param {?} error Current Error message that is being shown
     * @param {?} newErrorMessage New error message that must be shown
     * @return {?}
     */
    function (error, newErrorMessage) {
        this.removeFromErrorMap(error);
        this.getNextErrorIdFromErrorMap(error);
        var /** @type {?} */ index = this.findErrorIndex(this.errors, error);
        if (index > -1) {
            this.errors[index].message = newErrorMessage;
        }
        error.message = newErrorMessage;
        this.addToErrorMap(error);
    };
    /**
     * @return {?}
     */
    BfmErrorContainerComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.errors = [];
    };
    /**
     * @param {?} errorMessage
     * @return {?}
     */
    BfmErrorContainerComponent.prototype.isErrorMessagePresent = /**
     * @param {?} errorMessage
     * @return {?}
     */
    function (errorMessage) {
        return !!this.errorMap[errorMessage];
    };
    /**
     * @param {?} error
     * @return {?}
     */
    BfmErrorContainerComponent.prototype.getNextErrorIdFromErrorMap = /**
     * @param {?} error
     * @return {?}
     */
    function (error) {
        var /** @type {?} */ errorMessage = error.message;
        if (this.isErrorMessagePresent(errorMessage)) {
            var /** @type {?} */ errorMessageArray = this.errorMap[errorMessage];
            if (errorMessageArray.length > 0) {
                return errorMessageArray[0];
            }
        }
        return undefined;
    };
    /**
     * @param {?} error
     * @return {?}
     */
    BfmErrorContainerComponent.prototype.addToErrorMap = /**
     * @param {?} error
     * @return {?}
     */
    function (error) {
        var /** @type {?} */ errorMessage = error.message;
        var /** @type {?} */ errorMessageArray;
        if (!this.isErrorMessagePresent(errorMessage)) {
            this.errorMap[errorMessage] = errorMessageArray = [error];
        }
        else {
            // if the same error message is already present, pull out that
            // error array from the map and push the new error to its end
            errorMessageArray = this.errorMap[errorMessage];
            var /** @type {?} */ index = this.findErrorIndex(errorMessageArray, error);
            if (index === -1) {
                errorMessageArray.push(error);
            }
        }
        return errorMessageArray.length;
    };
    /**
     * @param {?} error
     * @return {?}
     */
    BfmErrorContainerComponent.prototype.removeFromErrorMap = /**
     * @param {?} error
     * @return {?}
     */
    function (error) {
        var /** @type {?} */ errorMessage = error.message;
        var /** @type {?} */ errorMessageArray;
        if (this.isErrorMessagePresent(errorMessage)) {
            errorMessageArray = this.errorMap[errorMessage];
            var /** @type {?} */ index = this.findErrorIndex(errorMessageArray, error);
            if (index > -1) {
                errorMessageArray.splice(index, 1);
            }
        }
        else {
            errorMessageArray = [];
        }
        return errorMessageArray.length;
    };
    /**
     * @param {?} errorArray
     * @param {?} errorObject
     * @return {?}
     */
    BfmErrorContainerComponent.prototype.findErrorIndex = /**
     * @param {?} errorArray
     * @param {?} errorObject
     * @return {?}
     */
    function (errorArray, errorObject) {
        return errorArray.findIndex(function (e) { return e.isErrorObjectSame(errorObject); });
    };
    /** @nocollapse */
    BfmErrorContainerComponent.ctorParameters = function () { return []; };
    BfmErrorContainerComponent.propDecorators = {
        "errors": [{ type: Input },],
    };
BfmErrorContainerComponent.ɵfac = function BfmErrorContainerComponent_Factory(t) { return new (t || BfmErrorContainerComponent)(); };
BfmErrorContainerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BfmErrorContainerComponent, selectors: [["bfm-error-container"]], inputs: { errors: "errors" }, decls: 4, vars: 4, consts: [["aria-live", "polite"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["defaultErrorContainerTemplate", ""], [3, "error", 4, "ngFor", "ngForOf"], [3, "error"]], template: function BfmErrorContainerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, BfmErrorContainerComponent_ng_container_1_Template, 1, 0, "ng-container", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(2, BfmErrorContainerComponent_ng_template_2_Template, 1, 1, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        var _r1 = ɵngcc0.ɵɵreference(3);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.errors.length && ctx.errorContainerTemplate ? ctx.errorContainerTemplate : _r1)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c2, ctx.errors));
    } }, directives: [ɵngcc1.NgTemplateOutlet, ɵngcc1.NgForOf, BfmErrorComponent], styles: [""] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BfmErrorContainerComponent, [{
        type: Component,
        args: [{
                selector: 'bfm-error-container',
                template: "<div aria-live=\"polite\">\n  <ng-container *ngTemplateOutlet=\"errors.length && errorContainerTemplate ? errorContainerTemplate : defaultErrorContainerTemplate; context:{errors:errors}\" >\n  </ng-container>\n</div>\n<ng-template #defaultErrorContainerTemplate>\n  <bfm-error *ngFor=\"let e of errors\" [error]=\"e\"></bfm-error>  \n</ng-template>",
                styles: [""]
            }]
    }], function () { return []; }, { errors: [{
            type: Input
        }] }); })();
    return BfmErrorContainerComponent;
}());
function BfmErrorContainerComponent_tsickle_Closure_declarations() {
    /** @type {!Array<{type: !Function, args: (undefined|!Array<?>)}>} */
    BfmErrorContainerComponent.decorators;
    /**
     * @nocollapse
     * @type {function(): !Array<(null|{type: ?, decorators: (undefined|!Array<{type: !Function, args: (undefined|!Array<?>)}>)})>}
     */
    BfmErrorContainerComponent.ctorParameters;
    /** @type {!Object<string,!Array<{type: !Function, args: (undefined|!Array<?>)}>>} */
    BfmErrorContainerComponent.propDecorators;
    /**
     * Holds list of errors inside a form
     * @type {?}
     */
    BfmErrorContainerComponent.prototype.errors;
    /** @type {?} */
    BfmErrorContainerComponent.prototype.errorContainerTemplate;
    /** @type {?} */
    BfmErrorContainerComponent.prototype.errorMap;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Code is extracted and revised from official NG 5 to support template outlets
 *
 * https://github.com/angular/angular/blob/master/packages/common/src/directives/ng_template_outlet.ts
 */
var BfmErrorRenderDirective = /** @class */ (function () {
    function BfmErrorRenderDirective(_viewContainerRef) {
        this._viewContainerRef = _viewContainerRef;
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    BfmErrorRenderDirective.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        var /** @type {?} */ recreateView = this._shouldRecreateView(changes);
        if (recreateView) {
            if (this._viewRef) {
                this._viewContainerRef.remove(this._viewContainerRef.indexOf(this._viewRef));
            }
            if (this.bfmRender) {
                this._viewRef = this._viewContainerRef.createEmbeddedView(this.bfmRender, this.bfmRenderContext);
            }
        }
        else {
            if (this._viewRef && this.bfmRenderContext) {
                this._updateExistingContext(this.bfmRenderContext);
            }
        }
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    BfmErrorRenderDirective.prototype._shouldRecreateView = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        var /** @type {?} */ ctxChange = changes['bfmRenderContext'];
        return !!changes['bfmRender'] || (ctxChange && this._hasContextShapeChanged(ctxChange));
    };
    /**
     * @param {?} ctxChange
     * @return {?}
     */
    BfmErrorRenderDirective.prototype._hasContextShapeChanged = /**
     * @param {?} ctxChange
     * @return {?}
     */
    function (ctxChange) {
        var e_1, _a;
        var /** @type {?} */ prevCtxKeys = Object.keys(ctxChange.previousValue || {});
        var /** @type {?} */ currCtxKeys = Object.keys(ctxChange.currentValue || {});
        if (prevCtxKeys.length === currCtxKeys.length) {
            try {
                for (var currCtxKeys_1 = __values(currCtxKeys), currCtxKeys_1_1 = currCtxKeys_1.next(); !currCtxKeys_1_1.done; currCtxKeys_1_1 = currCtxKeys_1.next()) {
                    var propName = currCtxKeys_1_1.value;
                    if (prevCtxKeys.indexOf(propName) === -1) {
                        return true;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (currCtxKeys_1_1 && !currCtxKeys_1_1.done && (_a = currCtxKeys_1.return)) _a.call(currCtxKeys_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return false;
        }
        else {
            return true;
        }
    };
    /**
     * @param {?} ctx
     * @return {?}
     */
    BfmErrorRenderDirective.prototype._updateExistingContext = /**
     * @param {?} ctx
     * @return {?}
     */
    function (ctx) {
        var e_2, _a;
        try {
            for (var _b = __values(Object.keys(ctx)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var propName = _c.value;
                this._viewRef.context[propName] = this.bfmRenderContext[propName];
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    /** @nocollapse */
    BfmErrorRenderDirective.ctorParameters = function () { return [
        { type: ViewContainerRef, },
    ]; };
    BfmErrorRenderDirective.propDecorators = {
        "bfmRenderContext": [{ type: Input },],
        "bfmRender": [{ type: Input },],
    };
BfmErrorRenderDirective.ɵfac = function BfmErrorRenderDirective_Factory(t) { return new (t || BfmErrorRenderDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
BfmErrorRenderDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BfmErrorRenderDirective, selectors: [["", "bfmRender", ""]], inputs: { bfmRenderContext: "bfmRenderContext", bfmRender: "bfmRender" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BfmErrorRenderDirective, [{
        type: Directive,
        args: [{
                selector: '[bfmRender]'
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }]; }, { bfmRenderContext: [{
            type: Input
        }], bfmRender: [{
            type: Input
        }] }); })();
    return BfmErrorRenderDirective;
}());
function BfmErrorRenderDirective_tsickle_Closure_declarations() {
    /** @type {!Array<{type: !Function, args: (undefined|!Array<?>)}>} */
    BfmErrorRenderDirective.decorators;
    /**
     * @nocollapse
     * @type {function(): !Array<(null|{type: ?, decorators: (undefined|!Array<{type: !Function, args: (undefined|!Array<?>)}>)})>}
     */
    BfmErrorRenderDirective.ctorParameters;
    /** @type {!Object<string,!Array<{type: !Function, args: (undefined|!Array<?>)}>>} */
    BfmErrorRenderDirective.propDecorators;
    /** @type {?} */
    BfmErrorRenderDirective.prototype.bfmRenderContext;
    /** @type {?} */
    BfmErrorRenderDirective.prototype.bfmRender;
    /** @type {?} */
    BfmErrorRenderDirective.prototype._viewRef;
    /** @type {?} */
    BfmErrorRenderDirective.prototype._viewContainerRef;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Event that is passed by BFM to error handler callback
 */
var  /**
 * Event that is passed by BFM to error handler callback
 */
BfmErrorHandlerEvent = /** @class */ (function () {
    function BfmErrorHandlerEvent(valid, message) {
        this.valid = valid;
        this.message = message;
    }
    return BfmErrorHandlerEvent;
}());
function BfmErrorHandlerEvent_tsickle_Closure_declarations() {
    /**
     * flag that represents if an error is present or not, based on this flag,
     * error handler can make decisions
     * @type {?}
     */
    BfmErrorHandlerEvent.prototype.valid;
    /**
     * error message if an error is present
     * @type {?}
     */
    BfmErrorHandlerEvent.prototype.message;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var BfmValidityEvent = /** @class */ (function () {
    function BfmValidityEvent(setValidity) {
        this.setValidity = setValidity;
    }
    return BfmValidityEvent;
}());
function BfmValidityEvent_tsickle_Closure_declarations() {
    /**
     * Callback function to respond to the validation process
     * \@param result
     * @type {?}
     */
    BfmValidityEvent.prototype.setValidity;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Event that is passed when BFM field needs validation
 */
var  /**
 * Event that is passed when BFM field needs validation
 */
BfmFieldEvent = /** @class */ (function (_super) {
    __extends(BfmFieldEvent, _super);
    /**
     * @param form
     * @param setValidity
     */
    function BfmFieldEvent(formControl, setValidity) {
        var _this = _super.call(this, setValidity) || this;
        _this.formControl = formControl;
        return _this;
    }
    return BfmFieldEvent;
}(BfmValidityEvent));
function BfmFieldEvent_tsickle_Closure_declarations() {
    /**
     * Form control that is related to this validation request event
     * @type {?}
     */
    BfmFieldEvent.prototype.formControl;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var BfmUtilsService = /** @class */ (function () {
    function BfmUtilsService() {
        this.defaultValidationMessages = {
            required: 'Error: {0} is required',
            email: 'Error: The {0} field pattern is not valid',
            minlength: 'Error: {0} must be at least {1} character(s)',
            maxlength: 'Error: {0} must be less than or equal to {1} character(s)',
            min: 'Error: {0} must be at least {1}',
            max: 'Error: {0} must be at most {1}',
            pattern: 'Error: Invalid {0} pattern',
            url: 'Error: {0} must be a valid URL',
            number: 'Error: {0} must be a number',
            unknown: 'Error: {0} is invalid',
            defaultgrouperror: 'Error: Some field(s) in {0} is invalid',
            validationTitle: 'Error: There are some validation errors'
        };
        this.errorIndex = 0;
    }
    /**
     * @return {?}
     */
    BfmUtilsService.prototype.getNewErrorIndex = /**
     * @return {?}
     */
    function () {
        return this.errorIndex++;
    };
    /**
     * @param {?} element
     * @param {?} name
     * @return {?}
     */
    BfmUtilsService.prototype.getElementAttributeToLowerCase = /**
     * @param {?} element
     * @param {?} name
     * @return {?}
     */
    function (element, name) {
        var /** @type {?} */ value;
        value = element[name];
        if (value && value.length) {
            value = value.toLowerCase();
        }
        return value;
    };
    /**
     * @return {?}
     */
    BfmUtilsService.prototype.generateRandomId = /**
     * @return {?}
     */
    function () {
        return Date.now() + Math.ceil(Math.random() * 9999);
    };
    /**
     * @param {?} element
     * @param {?} name
     * @param {?} value
     * @param {?=} forceSet
     * @return {?}
     */
    BfmUtilsService.prototype.setProperty = /**
     * @param {?} element
     * @param {?} name
     * @param {?} value
     * @param {?=} forceSet
     * @return {?}
     */
    function (element, name, value, forceSet) {
        if (forceSet === void 0) { forceSet = false; }
        // set the property only if not present or if set forcefully
        if (!element[name] || forceSet) {
            (value !== undefined && value !== null) ? element[name] = value :
                element[name] = true;
        }
    };
    /**
     * @param {?} element
     * @param {?} name
     * @param {?} value
     * @param {?=} forceSet
     * @return {?}
     */
    BfmUtilsService.prototype.setAttribute = /**
     * @param {?} element
     * @param {?} name
     * @param {?} value
     * @param {?=} forceSet
     * @return {?}
     */
    function (element, name, value, forceSet) {
        if (forceSet === void 0) { forceSet = false; }
        // set the attribute only if not present or if set forcefully
        if (!this.getAttribute(element, name) || forceSet) {
            (value !== undefined && value !== null) ?
                element.setAttribute(name, value) :
                element.setAttribute(name, 'true');
        }
    };
    /**
     * @param {?} element
     * @param {?} attributename
     * @return {?}
     */
    BfmUtilsService.prototype.hasAttribute = /**
     * @param {?} element
     * @param {?} attributename
     * @return {?}
     */
    function (element, attributename) {
        return element.hasAttribute(attributename);
    };
    /**
     * @param {?} element
     * @param {?} name
     * @return {?}
     */
    BfmUtilsService.prototype.getAttribute = /**
     * @param {?} element
     * @param {?} name
     * @return {?}
     */
    function (element, name) {
        return element.getAttribute(name);
    };
    /**
     * @param {?} element
     * @param {?} renderer
     * @return {?}
     */
    BfmUtilsService.prototype.isLabelAlreadyDefined = /**
     * @param {?} element
     * @param {?} renderer
     * @return {?}
     */
    function (element, renderer) {
        var /** @type {?} */ previousElement = element.previousElementSibling;
        var /** @type {?} */ parentElement = element.parentElement;
        var /** @type {?} */ parentPreviousElement = parentElement.previousElementSibling;
        var /** @type {?} */ labelElement;
        var /** @type {?} */ id = this.getAttribute(element, 'id');
        /**
             * 1. check if the previous element is 'label'
             * 2. or check if the input is surrounded by 'label'
             * 3. or check if the parent's previous element is a 'label' (bentoSelect)
             * 4. or check if input element's id attribute and any label's
             * 'for' attribute matches
             * (within this form)
             */
        if (previousElement &&
            this.getElementAttributeToLowerCase(previousElement, 'tagName') ===
                'label') {
            labelElement = previousElement;
        }
        else if (parentElement &&
            this.getElementAttributeToLowerCase(parentElement, 'tagName') ===
                'label') {
            labelElement = parentElement;
        }
        else if (parentPreviousElement &&
            this.getElementAttributeToLowerCase(parentPreviousElement, 'tagName') === 'label') {
            labelElement = parentPreviousElement;
        }
        /**
             * To avoid calling querySelector twice in the previous condition like this
             * else if(formElement[0].querySelector('label[for="'+id+'"]')) {
             *   labelElement = formElement[0].querySelector('label[for="'+id+'"]');
             * }
             * Putting this as a seperate condition when labelElement is not present.
             */
        if (!labelElement) {
            // labelElement = this.querySelector(renderer, 'label[for="' + id + '"]');
            labelElement = parentElement.querySelector('label[for="' + id + '"]');
        }
        return labelElement;
    };
    /**
     * @param {?} element
     * @return {?}
     */
    BfmUtilsService.prototype.isElementRadioOrCheckbox = /**
     * @param {?} element
     * @return {?}
     */
    function (element) {
        var /** @type {?} */ radioOrCheck = false;
        if (this.getElementAttributeToLowerCase(element, 'tagName') === 'input' &&
            (this.getElementAttributeToLowerCase(element, 'type') === 'radio' ||
                this.getElementAttributeToLowerCase(element, 'type') === 'checkbox')) {
            radioOrCheck = true;
        }
        return radioOrCheck;
    };
    /**
     * @param {?} element
     * @param {?} attrs
     * @param {?} renderer
     * @return {?}
     */
    BfmUtilsService.prototype.addLabel = /**
     * @param {?} element
     * @param {?} attrs
     * @param {?} renderer
     * @return {?}
     */
    function (element, attrs, renderer) {
        if (this.isElementRadioOrCheckbox(element)) {
            return;
        }
        var /** @type {?} */ labelElement = this.isLabelAlreadyDefined(element, renderer);
        if (labelElement && !this.getAttribute(element.parentElement, 'bfmGroup')) {
            /**
             * if present, verify 'for' attribute of the label &
             * 'id' attribute of the element to which it has to attach
             */
            var /** @type {?} */ forAttribute = this.getAttribute(labelElement, 'for');
            var /** @type {?} */ idAttribute = this.getAttribute(element, 'id');
            var /** @type {?} */ isGroup = this.getAttribute(element, 'bfmGroup');
            if (!isGroup && forAttribute !== idAttribute) {
                // only show this warning if the element is NOT a group
                console.warn('Non matching for & id attributes ', element);
            }
            this.setAttribute(labelElement, 'for', idAttribute);
        }
        else {
            var /** @type {?} */ labelName = element.getAttribute('bfmLabel') || element['name'] ||
                element['placeholder'] || '';
            var /** @type {?} */ requiredStar = (attrs['required'] || attrs['ngrequired']) ? '*' : '';
            labelElement = renderer.createElement('label');
            var /** @type {?} */ labelContent = renderer.createText(labelName + ' ' + requiredStar);
            this.setAttribute(labelElement, 'for', this.getAttribute(element, 'id'));
            labelElement.classList.add('bfm-sr-only');
            // this.setAttribute(labelElement, 'aria-hidden', true);
            // labelElement.style.display = 'none';
            renderer.appendChild(labelElement, labelContent);
            renderer.insertBefore(element.parentElement, labelElement, element);
        }
    };
    /**
     * @param {?} s
     * @return {?}
     */
    BfmUtilsService.prototype.UCFirst = /**
     * @param {?} s
     * @return {?}
     */
    function (s) {
        return (typeof s === 'string') ? s.charAt(0).toUpperCase() + s.slice(1) : s;
    };
    /**
     * @param {?} str
     * @return {?}
     */
    BfmUtilsService.prototype.formatCamelCaseString = /**
     * @param {?} str
     * @return {?}
     */
    function (str) {
        if (typeof str === 'number') {
            return str + '';
        }
        var /** @type {?} */ res = str.replace(/[A-Z0-9]/g, function (match) { return ' ' + match; });
        res = res.substr(0, 1).toUpperCase() + res.substr(1);
        return res.trim();
    };
    /**
     * @param {?} obj
     * @return {?}
     */
    BfmUtilsService.prototype.isEmptyObject = /**
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        var e_1, _a;
        if (obj) {
            try {
                for (var _b = __values(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var prop = _c.value;
                    if (obj.hasOwnProperty(prop)) {
                        return false;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        return true;
    };
    /**
     * @param {?} format
     * @param {?} name
     * @param {?} key
     * @return {?}
     */
    BfmUtilsService.prototype.formatValidationMessage = /**
     * @param {?} format
     * @param {?} name
     * @param {?} key
     * @return {?}
     */
    function (format, name, key) {
        if (format) {
            var /** @type {?} */ args_1 = Array.prototype.slice.call(arguments, 1);
            var /** @type {?} */ formattedString = format.replace(/{(\d+)}/g, function (match, n) { return typeof args_1[n] !== 'undefined' ? args_1[n] : match; });
            return formattedString.trim();
        }
        // no message with the attribute name
        return '';
    };
    /** @nocollapse */
    BfmUtilsService.ctorParameters = function () { return []; };
BfmUtilsService.ɵfac = function BfmUtilsService_Factory(t) { return new (t || BfmUtilsService)(); };
BfmUtilsService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: BfmUtilsService, factory: function (t) { return BfmUtilsService.ɵfac(t); } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BfmUtilsService, [{
        type: Injectable
    }], function () { return []; }, null); })();
    return BfmUtilsService;
}());
function BfmUtilsService_tsickle_Closure_declarations() {
    /** @type {!Array<{type: !Function, args: (undefined|!Array<?>)}>} */
    BfmUtilsService.decorators;
    /**
     * @nocollapse
     * @type {function(): !Array<(null|{type: ?, decorators: (undefined|!Array<{type: !Function, args: (undefined|!Array<?>)}>)})>}
     */
    BfmUtilsService.ctorParameters;
    /** @type {?} */
    BfmUtilsService.prototype.defaultValidationMessages;
    /** @type {?} */
    BfmUtilsService.prototype.errorIndex;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * `bfmForm` must be present on an enclosing ancestor element in order to use
 * any other **BFM NG** directives.
 */
var BfmFormDirective = /** @class */ (function () {
    function BfmFormDirective(controlContainer, factoryResolver, viewContainerRef, renderer, el, utils) {
        this.controlContainer = controlContainer;
        this.factoryResolver = factoryResolver;
        this.viewContainerRef = viewContainerRef;
        this.renderer = renderer;
        this.el = el;
        this.utils = utils;
        /**
         * Name of the element that will be used during error processing
         */
        this.name = '';
        /**
         * ID of the element that will be used during error processing
         */
        this.id = '';
        /**
         * Identifies from where the error originated - form/group/field
         */
        this.type = 'form';
        /**
         * Index of the error element in the same order as it the form fields
         * are rendered
         */
        this.errorElementIndex = -1;
        /**
         * a11y req: if there are any errors in the group, it's first
         * input element will be focused
         */
        this.firstInputElementId = '';
        /**
         * A callback function allowing arbitrary error handling logic.
         * When to use: If you wish to manipulate other components in response to
         * errors; for example, to spawn a bento-alert.
         * How to override: Child elements of a parent configured to use
         * `error-handler` will inherit this behavior; to exempt any child element,
         * specify `error-handler=null` on the child.
         */
        this.errorHandler = new EventEmitter();
        /**
         * (default is `false`) Flag to enable/show server side errors
         */
        this.showServerError = false;
    }
    Object.defineProperty(BfmFormDirective.prototype, "submitted", {
        set: /**
         * (default is `undefined`) Flag to inform the BfmForm that form is being submitted.
         * When to use: To show errors for the required fields that are pristine.
         * Note: This flag must be reset to either `undefined` or `false` after use.
         * Checkout `Register` demo for more on how to reset the flag.
         * @param {?} submitted
         * @return {?}
         */
        function (submitted) {
            this._formSubmitted = submitted;
            this.formSubmittedSubject && this.formSubmittedSubject.next(submitted);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BfmFormDirective.prototype, "formSubmitted", {
        get: /**
         * @return {?}
         */
        function () {
            return this._formSubmitted;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BfmFormDirective.prototype, "resetErrors", {
        get: /**
         * @return {?}
         */
        function () {
            return this._resetErrors;
        },
        set: /**
         * (default is `undefined`) Flag to clear all BFM related errors.
         * Note: This flag must be reset to either `undefined` or `false` after use.
         * Checkout `Simple Login Example` demo for more on how to reset the flag.
         * @param {?} reset
         * @return {?}
         */
        function (reset) {
            this._resetErrors = reset;
            this.resetErrorsSubject && this.resetErrorsSubject.next(reset);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Call this method to process **server** errors.
     *
     * If the `name` property of a `ValidationErrors` object matches a field
     * name, this method will highlight that field with an error message provided
     * by the server.
     *
     * _Parameter:_ `formObject:FormGroup`<br>
     * Form object.
     *
     * _Parameter:_ `fieldList:QueryList<BfmFieldDirective>`<br>
     * List of BFM fields.
     *
     * _Parameter:_ `validationErrors:Object`<br>
     * Simple name value pair object; the name describes the field name, and the
     * value is the error message.<br>
     * E.g., `{'EmailID': 'Invalid EmailID'}`
     */
    /**
     * Call this method to process **server** errors.
     *
     * If the `name` property of a `ValidationErrors` object matches a field
     * name, this method will highlight that field with an error message provided
     * by the server.
     *
     * _Parameter:_ `formObject:FormGroup`<br>
     * Form object.
     *
     * _Parameter:_ `fieldList:QueryList<BfmFieldDirective>`<br>
     * List of BFM fields.
     *
     * _Parameter:_ `validationErrors:Object`<br>
     * Simple name value pair object; the name describes the field name, and the
     * value is the error message.<br>
     * E.g., `{'EmailID': 'Invalid EmailID'}`
     * @param {?} formObject
     * @param {?} fieldList
     * @param {?} validationErrors
     * @return {?}
     */
    BfmFormDirective.prototype.processServerError = /**
     * Call this method to process **server** errors.
     *
     * If the `name` property of a `ValidationErrors` object matches a field
     * name, this method will highlight that field with an error message provided
     * by the server.
     *
     * _Parameter:_ `formObject:FormGroup`<br>
     * Form object.
     *
     * _Parameter:_ `fieldList:QueryList<BfmFieldDirective>`<br>
     * List of BFM fields.
     *
     * _Parameter:_ `validationErrors:Object`<br>
     * Simple name value pair object; the name describes the field name, and the
     * value is the error message.<br>
     * E.g., `{'EmailID': 'Invalid EmailID'}`
     * @param {?} formObject
     * @param {?} fieldList
     * @param {?} validationErrors
     * @return {?}
     */
    function (formObject, fieldList, validationErrors) {
        var _this = this;
        var /** @type {?} */ fieldName;
        var /** @type {?} */ displayedFieldNameList = [];
        // errors that needs to be fixed for individual fields
        this.showServerError &&
            fieldList.forEach(function (field) {
                fieldName = field.name;
                if (validationErrors[fieldName]) {
                    var /** @type {?} */ errorObject = { valid: false, message: validationErrors[fieldName] };
                    field.inspectForErrorFromForm(errorObject);
                    displayedFieldNameList.push(fieldName);
                }
            });
        // form errors
        Object.keys(validationErrors).forEach(function (prop) {
            // this property is not present, show it as form error
            if (displayedFieldNameList.indexOf(prop) === -1) {
                _this.addError(validationErrors[prop] || '__UNKNOWN_ERROR__');
            }
        });
    };
    /**
     * @return {?}
     */
    BfmFormDirective.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        // you need server error container to show server errors, if not
        // defined, create one
        if (this.showServerError && !this.serverErrorContainer) {
            var /** @type {?} */ factory = this.factoryResolver.resolveComponentFactory(BfmErrorContainerComponent);
            var /** @type {?} */ componentRef = this.viewContainerRef.createComponent(factory);
            this.serverErrorContainer = componentRef.instance;
        }
        this.formSubmittedSubject = new BehaviorSubject(this.submitted);
        this.resetErrorsSubject = new BehaviorSubject(this.resetErrors);
    };
    /**
     * @return {?}
     */
    BfmFormDirective.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        // a11y req: if there are any errors in the group, it's first
        // input element will be focused
        var /** @type {?} */ firstInputEl = this.el.nativeElement.querySelector('input');
        if (firstInputEl) {
            this.firstInputElementId = this.utils.getAttribute(firstInputEl, 'id');
        }
        else {
            // fall back to the group element
            this.firstInputElementId = this.id;
        }
    };
    /**
     * @return {?}
     */
    BfmFormDirective.prototype.clearError = /**
     * @return {?}
     */
    function () {
        this.removeError();
    };
    /**
     * @param {?} message
     * @return {?}
     */
    BfmFormDirective.prototype.addError = /**
     * @param {?} message
     * @return {?}
     */
    function (message) {
        if (!this.error) {
            this.error = new BfmError(message, this.firstInputElementId, 'notify' + this.id, this.errorElementIndex, this.formName, {}, this.errorTemplate);
            this.serverErrorContainer.addError(this.error);
        }
        else if (this.error.message !== message) {
            this.serverErrorContainer.removeError(this.error);
            delete this.error;
            this.error = new BfmError(message, this.firstInputElementId, 'notify' + this.id, this.errorElementIndex, this.formName, {}, this.errorTemplate);
            this.serverErrorContainer.addError(this.error);
        }
        this.renderer.setAttribute(this.el.nativeElement, 'aria-invalid', 'true');
        this.setFormError(message);
    };
    /**
     * @return {?}
     */
    BfmFormDirective.prototype.removeError = /**
     * @return {?}
     */
    function () {
        this.renderer.setAttribute(this.el.nativeElement, 'aria-invalid', 'false');
        if (this.error) {
            this.serverErrorContainer.removeError(this.error);
            delete this.error;
            this.error = null;
        }
    };
    /**
     * @param {?} message
     * @return {?}
     */
    BfmFormDirective.prototype.setFormError = /**
     * @param {?} message
     * @return {?}
     */
    function (message) {
        var /** @type {?} */ name = this.controlContainer.name || 'Form';
        if (message) {
            var /** @type {?} */ errorObject = { serverError: {} };
            errorObject.serverError[name] = message;
            this.controlContainer.control.setErrors(errorObject);
        }
        else if (this.controlContainer.control.hasError('serverError')) {
            delete this.controlContainer.control.errors['serverError'];
        }
    };
    /** @nocollapse */
    BfmFormDirective.ctorParameters = function () { return [
        { type: ControlContainer, },
        { type: ComponentFactoryResolver, },
        { type: ViewContainerRef, },
        { type: Renderer2, },
        { type: ElementRef, },
        { type: BfmUtilsService, },
    ]; };
    BfmFormDirective.propDecorators = {
        "muteError": [{ type: Input },],
        "errorContainer": [{ type: Input },],
        "errorHandler": [{ type: Output },],
        "errorTemplate": [{ type: Input, args: ['errorTemplate',] },],
        "errorContainerTemplate": [{ type: Input, args: ['errorContainerTemplate',] },],
        "resetToDefaultErrorContainerTemplate": [{ type: Input },],
        "validations": [{ type: Input },],
        "validateOnBlurOnly": [{ type: Input },],
        "showFieldLevelErrorContainer": [{ type: Input },],
        "showErrorIndicator": [{ type: Input },],
        "instantValidation": [{ type: Input },],
        "showServerError": [{ type: Input },],
        "serverErrorContainer": [{ type: Input },],
        "submitted": [{ type: Input, args: ['formSubmitted',] },],
        "resetErrors": [{ type: Input, args: ['resetErrors',] },],
    };
BfmFormDirective.ɵfac = function BfmFormDirective_Factory(t) { return new (t || BfmFormDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.ControlContainer), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(BfmUtilsService)); };
BfmFormDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BfmFormDirective, selectors: [["", "bfmForm", ""]], inputs: { showServerError: "showServerError", submitted: ["formSubmitted", "submitted"], resetErrors: "resetErrors", serverErrorContainer: "serverErrorContainer", muteError: "muteError", errorContainer: "errorContainer", errorTemplate: "errorTemplate", errorContainerTemplate: "errorContainerTemplate", resetToDefaultErrorContainerTemplate: "resetToDefaultErrorContainerTemplate", validations: "validations", validateOnBlurOnly: "validateOnBlurOnly", showFieldLevelErrorContainer: "showFieldLevelErrorContainer", showErrorIndicator: "showErrorIndicator", instantValidation: "instantValidation" }, outputs: { errorHandler: "errorHandler" } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BfmFormDirective, [{
        type: Directive,
        args: [{ selector: '[bfmForm]' }]
    }], function () { return [{ type: ɵngcc2.ControlContainer }, { type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: BfmUtilsService }]; }, { errorHandler: [{
            type: Output
        }], showServerError: [{
            type: Input
        }], submitted: [{
            type: Input,
            args: ['formSubmitted']
        }], resetErrors: [{
            type: Input,
            args: ['resetErrors']
        }], serverErrorContainer: [{
            type: Input
        }], muteError: [{
            type: Input
        }], errorContainer: [{
            type: Input
        }], errorTemplate: [{
            type: Input,
            args: ['errorTemplate']
        }], errorContainerTemplate: [{
            type: Input,
            args: ['errorContainerTemplate']
        }], resetToDefaultErrorContainerTemplate: [{
            type: Input
        }], validations: [{
            type: Input
        }], validateOnBlurOnly: [{
            type: Input
        }], showFieldLevelErrorContainer: [{
            type: Input
        }], showErrorIndicator: [{
            type: Input
        }], instantValidation: [{
            type: Input
        }] }); })();
    return BfmFormDirective;
}());
function BfmFormDirective_tsickle_Closure_declarations() {
    /** @type {!Array<{type: !Function, args: (undefined|!Array<?>)}>} */
    BfmFormDirective.decorators;
    /**
     * @nocollapse
     * @type {function(): !Array<(null|{type: ?, decorators: (undefined|!Array<{type: !Function, args: (undefined|!Array<?>)}>)})>}
     */
    BfmFormDirective.ctorParameters;
    /** @type {!Object<string,!Array<{type: !Function, args: (undefined|!Array<?>)}>>} */
    BfmFormDirective.propDecorators;
    /**
     * Name of the element that will be used during error processing
     * @type {?}
     */
    BfmFormDirective.prototype.name;
    /**
     * ID of the element that will be used during error processing
     * @type {?}
     */
    BfmFormDirective.prototype.id;
    /**
     * Identifies from where the error originated - form/group/field
     * @type {?}
     */
    BfmFormDirective.prototype.type;
    /**
     * Index of the error element in the same order as it the form fields
     * are rendered
     * @type {?}
     */
    BfmFormDirective.prototype.errorElementIndex;
    /**
     * Name of the form
     * @type {?}
     */
    BfmFormDirective.prototype.formName;
    /**
     * a11y req: if there are any errors in the group, it's first
     * input element will be focused
     * @type {?}
     */
    BfmFormDirective.prototype.firstInputElementId;
    /**
     * (default is `false`) Set to `true` on a per-element basis to mute any error
     * reporting. When to use: If a customized error-handler is in use,
     * for example when calling a bento-alert, set this attribute to `true` to
     * mute default errors.
     * @type {?}
     */
    BfmFormDirective.prototype.muteError;
    /**
     * Defines the position where the error elements will be placed if one is not
     * specified. They are rendered by default after each each **BfmField**. To
     * override the default position, place the following template as per your
     * UX demands. <br/>
     * `<bfm-error-container
     * #idToBeReferredByErrorContainer></bfm-error-container>`
     * @type {?}
     */
    BfmFormDirective.prototype.errorContainer;
    /**
     * A callback function allowing arbitrary error handling logic.
     * When to use: If you wish to manipulate other components in response to
     * errors; for example, to spawn a bento-alert.
     * How to override: Child elements of a parent configured to use
     * `error-handler` will inherit this behavior; to exempt any child element,
     * specify `error-handler=null` on the child.
     * @type {?}
     */
    BfmFormDirective.prototype.errorHandler;
    /**
     * User defined error template, if provided. This is the default template
     * provided by **BFM NG** <br/>
     * `<ng-template #defaultErrorTemplate let-error="error"><span>{{
     * error.message }}</span></ng-template>`.<br/> Developers can override
     * default template using `errorTemplate`, with different template ID.
     * @type {?}
     */
    BfmFormDirective.prototype.errorTemplate;
    /**
     * User defined error template to override the default error template. This
     * is the default template provided by **BFM NG**
     * <br/>
     * `<ng-template #defaultErrorContainerTemplate><bfm-error *ngFor="let e of
     * errors" [error]="e"></bfm-error> </ng-template>`.
     * @type {?}
     */
    BfmFormDirective.prototype.errorContainerTemplate;
    /**
     * (default is `false`) Set to `true` on a per-element basis to over ride
     * parent error template.
     * When to use: When a customized errorContainerTemplate is used at the parent
     * level and if any group or field wants to use the default template
     * @type {?}
     */
    BfmFormDirective.prototype.resetToDefaultErrorContainerTemplate;
    /**
     * This defines the list of elements that BFM will monitor, identified by the
     * validation attributes (`required`, `min`, `max`, `minlength`, `maxlength`)
     * @type {?}
     */
    BfmFormDirective.prototype.validations;
    /**
     * (default is `false`) Flag that validates form field only during focus out.
     * If set to true, BFM will not show error messages instantly as on when the
     * user is keying in the values.
     * @type {?}
     */
    BfmFormDirective.prototype.validateOnBlurOnly;
    /**
     * A11y req: (default is `false`) Set to `true` on a per-element basis to
     * show field level error container (fieldLevelError) if any explicit
     * errorContainer is provided by the dev
     * @type {?}
     */
    BfmFormDirective.prototype.showFieldLevelErrorContainer;
    /**
     * A11y req: (default is `false`) Set to `true` on a per-element basis to
     * show an error icon right next to each error field
     * @type {?}
     */
    BfmFormDirective.prototype.showErrorIndicator;
    /**
     * (default is `false`) Flag to enable instant field validation as soon as the
     * user enters any value to the field. In other words when NgControl's `dirty`
     * property is set to true; irrespective of whether NgControl's `touched`
     * property is set to true or not.
     * @type {?}
     */
    BfmFormDirective.prototype.instantValidation;
    /**
     * (default is `false`) Flag to enable/show server side errors
     * @type {?}
     */
    BfmFormDirective.prototype.showServerError;
    /**
     * Defines the position where the server error for the entire form will be
     * placed, By default they are rendered before **BfmForm**. To override the
     * default position, place the following template as per your UX demands.
     * <br/>
     * `<bfm-error-container
     * #idToBeReferredByErrorContainer></bfm-error-container>`
     * @type {?}
     */
    BfmFormDirective.prototype.serverErrorContainer;
    /** @type {?} */
    BfmFormDirective.prototype.formSubmittedSubject;
    /** @type {?} */
    BfmFormDirective.prototype._formSubmitted;
    /** @type {?} */
    BfmFormDirective.prototype.resetErrorsSubject;
    /** @type {?} */
    BfmFormDirective.prototype._resetErrors;
    /**
     * Error object used to add and remove error inside the error container
     * @type {?}
     */
    BfmFormDirective.prototype.error;
    /** @type {?} */
    BfmFormDirective.prototype.controlContainer;
    /** @type {?} */
    BfmFormDirective.prototype.factoryResolver;
    /** @type {?} */
    BfmFormDirective.prototype.viewContainerRef;
    /** @type {?} */
    BfmFormDirective.prototype.renderer;
    /** @type {?} */
    BfmFormDirective.prototype.el;
    /** @type {?} */
    BfmFormDirective.prototype.utils;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Event that is passed when BFM group needs validation
 */
var  /**
 * Event that is passed when BFM group needs validation
 */
BfmGroupEvent = /** @class */ (function (_super) {
    __extends(BfmGroupEvent, _super);
    /**
     * @param formGroup
     * @param setValidity
     */
    function BfmGroupEvent(formGroup, setValidity) {
        var _this = _super.call(this, setValidity) || this;
        _this.formGroup = formGroup;
        return _this;
    }
    return BfmGroupEvent;
}(BfmValidityEvent));
function BfmGroupEvent_tsickle_Closure_declarations() {
    /**
     * Form group that is related to this validation request event
     * @type {?}
     */
    BfmGroupEvent.prototype.formGroup;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * This directive manages group-level validation. Within a large form, you may
 * wish to divide your collection of elements into groups that can be treated as
 * discrete sub-sections. The most obvious use would be for radio buttons and
 * checkboxes - but literally anything could be grouped to support your business
 * logic.
 *
 * Set the `bfmGroup` attribute - giving it a unique value - on an enclosing
 * element. Every child element in the group that **BFM NG** will monitor must
 * have the [`bfmField`](#bfmField) attribute.
 *  Please note that each group can _either_ have its own `validations`
 * attribute associated with its own validation object, _or_ can inherit
 * configuration from the parent form. In the latter case, the parent
 * `validations` object _must_ include keys for the grouped child elements, as
 * well as for other non-grouped
 * **BFM NG** elements.
 */
var BfmGroupDirective = /** @class */ (function () {
    function BfmGroupDirective(controlContainer, parentForm, parentGroup, factoryResolver, el, utils, renderer, viewContainerRef) {
        this.controlContainer = controlContainer;
        this.parentForm = parentForm;
        this.parentGroup = parentGroup;
        this.factoryResolver = factoryResolver;
        this.el = el;
        this.utils = utils;
        this.renderer = renderer;
        this.viewContainerRef = viewContainerRef;
        /**
         * Name of the element that will be used during error processing
         */
        this.name = '';
        /**
         * ID of the element that will be used during error processing
         */
        this.id = '';
        /**
         * Identifies from where the error originated - form/group/field
         */
        this.type = 'group';
        /**
         * Index of the error element in the same order as it the form fields
         * are rendered
         */
        this.errorElementIndex = -1;
        /**
         * a11y req: if there are any errors in the group, it's first
         * input element will be focused
         */
        this.firstInputElementId = '';
        /**
         * A callback function allowing arbitrary error handling logic.
         * When to use: If you wish to manipulate other components in response to
         * errors; for example, to spawn a bento-alert.
         * How to override: Child elements of a parent configured to use
         * `error-handler` will inherit this behavior; to exempt any child element,
         * specify `error-handler=null` on the child.
         */
        this.errorHandler = new EventEmitter();
        /**
         * Callback function that will be called if the FormGroup entries are valid.
         * Devs can decide whether the group as a whole is valid or not based on their
         * business logic
         */
        this.groupValidate = new EventEmitter();
        /**
         * Flag to use the group level error container for all field errors that are
         * inside this group.
         */
        this.useErrorContainerForFieldErrors = false;
        this.statusChangeSubscription = Subscription.EMPTY;
        this.resetErrorsSubjectSubscription = Subscription.EMPTY;
    }
    /**
     * @return {?}
     */
    BfmGroupDirective.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        setTimeout(function () {
            if (_this.controlContainer instanceof NgModelGroup) {
                _this.statusChangeSubscription = _this.controlContainer.statusChanges.subscribe(function (status) {
                    _this.validate(status);
                });
            }
            else if (_this.controlContainer instanceof FormGroupName) {
                _this.statusChangeSubscription = _this.controlContainer.statusChanges.subscribe(function (status) {
                    _this.validate(status);
                });
            }
        });
        this.errorContainer =
            this.errorContainer ||
                (this.parentGroup ? this.parentGroup.errorContainer : undefined) ||
                this.parentForm.errorContainer;
        // you need group level error container to show group errors, if not
        // defined, create one
        if (!this.errorContainer) {
            var /** @type {?} */ factory = this.factoryResolver.resolveComponentFactory(BfmErrorContainerComponent);
            var /** @type {?} */ component = factory.create(this.viewContainerRef.parentInjector);
            this.viewContainerRef.insert(component.hostView);
            this.errorContainer = component.instance;
        }
        if (!this.resetToDefaultErrorTemplate) {
            this.errorTemplate =
                this.errorTemplate ||
                    (this.parentGroup ? this.parentGroup.errorTemplate : undefined) ||
                    this.parentForm.errorTemplate ||
                    undefined;
        }
        if (!this.resetToDefaultErrorContainerTemplate) {
            this.errorContainerTemplate =
                this.errorContainerTemplate ||
                    (this.parentGroup ? this.parentGroup.errorContainerTemplate : undefined) ||
                    this.parentForm.errorContainerTemplate ||
                    undefined;
        }
        this.validateOnBlurOnly =
            this.validateOnBlurOnly ||
                (this.parentGroup ? this.parentGroup.validateOnBlurOnly : undefined) ||
                this.parentForm.validateOnBlurOnly;
        this.instantValidation =
            this.instantValidation ||
                (this.parentGroup ? this.parentGroup.instantValidation : undefined) ||
                this.parentForm.instantValidation;
        this.resetErrorsSubjectSubscription = this.parentForm.resetErrorsSubject.subscribe(function (reset) {
            if (reset) {
                _this.removeError();
            }
        });
    };
    /**
     * Once the component is initialized, BFM starts inspecting the field and sets
     * id, label based on the need
     */
    /**
     * Once the component is initialized, BFM starts inspecting the field and sets
     * id, label based on the need
     * @return {?}
     */
    BfmGroupDirective.prototype.ngAfterViewInit = /**
     * Once the component is initialized, BFM starts inspecting the field and sets
     * id, label based on the need
     * @return {?}
     */
    function () {
        var _this = this;
        this.setId(this.el.nativeElement);
        this.utils.addLabel(this.el.nativeElement, this.el.nativeElement.attributes, this.renderer);
        this.id = this.utils.getAttribute(this.el.nativeElement, 'id');
        // a11y req: if there are any errors in the group, it's first
        // input element will be focused
        var /** @type {?} */ firstInputEl = this.el.nativeElement.querySelector('input');
        if (firstInputEl) {
            this.firstInputElementId = this.utils.getAttribute(firstInputEl, 'id');
        }
        else {
            // fall back to the group element
            this.firstInputElementId = this.id;
        }
        this.errorElementIndex = this.utils.getNewErrorIndex();
        this.groupName = this.el.nativeElement.getAttribute('ngModelGroup');
        if (this.groupName && this.groupName.length) {
            this.groupName = this.utils.formatCamelCaseString(this.groupName);
        }
        this.renderer.setAttribute(this.el.nativeElement, 'aria-invalid', 'false');
        // this.renderer.setAttribute(this.el.nativeElement, 'aria-labelledby',
        // this.id);
        this.renderer.setAttribute(this.el.nativeElement, 'aria-errormessage', 'notify' + this.id);
        if (this.options) {
            setTimeout(function () {
                _this.validate('VALID');
            });
        }
    };
    /**
     * Garbage cleaning
     */
    /**
     * Garbage cleaning
     * @return {?}
     */
    BfmGroupDirective.prototype.ngOnDestroy = /**
     * Garbage cleaning
     * @return {?}
     */
    function () {
        this.removeError();
        this.statusChangeSubscription.unsubscribe();
        this.resetErrorsSubjectSubscription.unsubscribe();
    };
    /**
     * @param {?} element
     * @return {?}
     */
    BfmGroupDirective.prototype.setId = /**
     * @param {?} element
     * @return {?}
     */
    function (element) {
        var /** @type {?} */ idValue = this.utils.generateRandomId();
        // set `id` attribute, if not present - `setAttribute` won't add if `id`
        // value is already present
        this.utils.setProperty(element, 'id', idValue, false);
    };
    /**
     * @param {?} status
     * @return {?}
     */
    BfmGroupDirective.prototype.validate = /**
     * @param {?} status
     * @return {?}
     */
    function (status) {
        var _this = this;
        if (status === 'VALID') {
            this.groupValidate.emit(new BfmGroupEvent(this.controlContainer.control, function (result) {
                if (!result.valid) {
                    _this.addError(result.message || '__UNKNOWN_ERROR__');
                }
                else {
                    _this.removeError();
                }
            }));
        }
    };
    /**
     * @param {?} message
     * @return {?}
     */
    BfmGroupDirective.prototype.addError = /**
     * @param {?} message
     * @return {?}
     */
    function (message) {
        if (!this.error) {
            this.error = new BfmError(message, this.firstInputElementId, 'notify' + this.id, this.errorElementIndex, this.groupName, {}, this.errorTemplate);
            this.errorContainer.addError(this.error);
        }
        else if (this.error.message !== message) {
            this.errorContainer.removeError(this.error);
            delete this.error;
            this.error = new BfmError(message, this.firstInputElementId, 'notify' + this.id, this.errorElementIndex, this.groupName, {}, this.errorTemplate);
            this.errorContainer.addError(this.error);
        }
        this.renderer.setAttribute(this.el.nativeElement, 'aria-invalid', 'true');
        this.setFormError(message);
    };
    /**
     * @return {?}
     */
    BfmGroupDirective.prototype.removeError = /**
     * @return {?}
     */
    function () {
        this.renderer.setAttribute(this.el.nativeElement, 'aria-invalid', 'false');
        if (this.error) {
            this.errorContainer.removeError(this.error);
            delete this.error;
            this.error = null;
        }
    };
    /**
     * @param {?} message
     * @return {?}
     */
    BfmGroupDirective.prototype.setFormError = /**
     * @param {?} message
     * @return {?}
     */
    function (message) {
        var /** @type {?} */ name = this.controlContainer.name || 'Group';
        if (message) {
            var /** @type {?} */ errorObject = { groupError: {} };
            errorObject.groupError[name] = message;
            this.controlContainer.control.setErrors(errorObject);
        }
        else if (this.controlContainer.control.hasError('groupError')) {
            delete this.controlContainer.control.errors['groupError'];
        }
    };
    /** @nocollapse */
    BfmGroupDirective.ctorParameters = function () { return [
        { type: ControlContainer, },
        { type: BfmFormDirective, },
        { type: BfmGroupDirective, decorators: [{ type: SkipSelf }, { type: Optional },] },
        { type: ComponentFactoryResolver, },
        { type: ElementRef, },
        { type: BfmUtilsService, },
        { type: Renderer2, },
        { type: ViewContainerRef, },
    ]; };
    BfmGroupDirective.propDecorators = {
        "bfmLabel": [{ type: Input },],
        "muteError": [{ type: Input },],
        "errorContainer": [{ type: Input },],
        "errorHandler": [{ type: Output },],
        "errorTemplate": [{ type: Input, args: ['errorTemplate',] },],
        "errorContainerTemplate": [{ type: Input, args: ['errorContainerTemplate',] },],
        "validations": [{ type: Input },],
        "validateOnBlurOnly": [{ type: Input },],
        "resetToDefaultErrorTemplate": [{ type: Input },],
        "resetToDefaultErrorContainerTemplate": [{ type: Input },],
        "showFieldLevelErrorContainer": [{ type: Input },],
        "options": [{ type: Input },],
        "groupValidate": [{ type: Output },],
        "showErrorIndicator": [{ type: Input },],
        "instantValidation": [{ type: Input },],
        "useErrorContainerForFieldErrors": [{ type: Input },],
    };
BfmGroupDirective.ɵfac = function BfmGroupDirective_Factory(t) { return new (t || BfmGroupDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.ControlContainer), ɵngcc0.ɵɵdirectiveInject(BfmFormDirective), ɵngcc0.ɵɵdirectiveInject(BfmGroupDirective, 12), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(BfmUtilsService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
BfmGroupDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BfmGroupDirective, selectors: [["", "bfmGroup", ""]], inputs: { useErrorContainerForFieldErrors: "useErrorContainerForFieldErrors", errorContainer: "errorContainer", errorTemplate: "errorTemplate", errorContainerTemplate: "errorContainerTemplate", validateOnBlurOnly: "validateOnBlurOnly", instantValidation: "instantValidation", bfmLabel: "bfmLabel", muteError: "muteError", validations: "validations", resetToDefaultErrorTemplate: "resetToDefaultErrorTemplate", resetToDefaultErrorContainerTemplate: "resetToDefaultErrorContainerTemplate", showFieldLevelErrorContainer: "showFieldLevelErrorContainer", options: "options", showErrorIndicator: "showErrorIndicator" }, outputs: { errorHandler: "errorHandler", groupValidate: "groupValidate" } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BfmGroupDirective, [{
        type: Directive,
        args: [{ selector: '[bfmGroup]' }]
    }], function () { return [{ type: ɵngcc2.ControlContainer }, { type: BfmFormDirective }, { type: BfmGroupDirective, decorators: [{
                type: SkipSelf
            }, {
                type: Optional
            }] }, { type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.ElementRef }, { type: BfmUtilsService }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ViewContainerRef }]; }, { errorHandler: [{
            type: Output
        }], groupValidate: [{
            type: Output
        }], useErrorContainerForFieldErrors: [{
            type: Input
        }], errorContainer: [{
            type: Input
        }], errorTemplate: [{
            type: Input,
            args: ['errorTemplate']
        }], errorContainerTemplate: [{
            type: Input,
            args: ['errorContainerTemplate']
        }], validateOnBlurOnly: [{
            type: Input
        }], instantValidation: [{
            type: Input
        }], bfmLabel: [{
            type: Input
        }], muteError: [{
            type: Input
        }], validations: [{
            type: Input
        }], resetToDefaultErrorTemplate: [{
            type: Input
        }], resetToDefaultErrorContainerTemplate: [{
            type: Input
        }], showFieldLevelErrorContainer: [{
            type: Input
        }], options: [{
            type: Input
        }], showErrorIndicator: [{
            type: Input
        }] }); })();
    return BfmGroupDirective;
}());
function BfmGroupDirective_tsickle_Closure_declarations() {
    /** @type {!Array<{type: !Function, args: (undefined|!Array<?>)}>} */
    BfmGroupDirective.decorators;
    /**
     * @nocollapse
     * @type {function(): !Array<(null|{type: ?, decorators: (undefined|!Array<{type: !Function, args: (undefined|!Array<?>)}>)})>}
     */
    BfmGroupDirective.ctorParameters;
    /** @type {!Object<string,!Array<{type: !Function, args: (undefined|!Array<?>)}>>} */
    BfmGroupDirective.propDecorators;
    /**
     * Name of the element that will be used during error processing
     * @type {?}
     */
    BfmGroupDirective.prototype.name;
    /**
     * ID of the element that will be used during error processing
     * @type {?}
     */
    BfmGroupDirective.prototype.id;
    /**
     * Identifies from where the error originated - form/group/field
     * @type {?}
     */
    BfmGroupDirective.prototype.type;
    /**
     * Index of the error element in the same order as it the form fields
     * are rendered
     * @type {?}
     */
    BfmGroupDirective.prototype.errorElementIndex;
    /**
     * Name of the form field - either value of bfmLabel or name/formControlName
     * attribute value
     * @type {?}
     */
    BfmGroupDirective.prototype.groupName;
    /**
     * a11y req: if there are any errors in the group, it's first
     * input element will be focused
     * @type {?}
     */
    BfmGroupDirective.prototype.firstInputElementId;
    /**
     * Label for the input element. BFM will use this label when showing errors
     * @type {?}
     */
    BfmGroupDirective.prototype.bfmLabel;
    /**
     * (default is `false`) Set to `true` on a per-element basis to mute any error
     * reporting. When to use: If a customized error-handler is in use,
     * for example when calling a bento-alert, set this attribute to `true` to
     * mute default errors.
     * @type {?}
     */
    BfmGroupDirective.prototype.muteError;
    /**
     * Defines the position where the error elements will be placed, if one is not
     * specified. They are rendered by default after each **BfmField**. To
     * override the default position, place the following template as per your
     * UX demands. <br/>
     * `<bfm-error-container
     * #idToBeReferredByErrorContainer></bfm-error-container>`
     * @type {?}
     */
    BfmGroupDirective.prototype.errorContainer;
    /**
     * A callback function allowing arbitrary error handling logic.
     * When to use: If you wish to manipulate other components in response to
     * errors; for example, to spawn a bento-alert.
     * How to override: Child elements of a parent configured to use
     * `error-handler` will inherit this behavior; to exempt any child element,
     * specify `error-handler=null` on the child.
     * @type {?}
     */
    BfmGroupDirective.prototype.errorHandler;
    /**
     * User defined error template, if provided. This is the default template
     * provided by **BFM NG** <br/>
     * `<ng-template #defaultErrorTemplate let-error="error"><span>{{
     * error.message }}</span></ng-template>`.<br/> Developers can override
     * default template using `errorTemplate`, with different template ID.
     * @type {?}
     */
    BfmGroupDirective.prototype.errorTemplate;
    /**
     * User defined error template to override the default error template. This
     * is the default template provided by **BFM NG**
     * <br/>
     * `<ng-template #defaultErrorContainerTemplate><bfm-error *ngFor="let e of
     * errors" [error]="e"></bfm-error> </ng-template>`.
     * @type {?}
     */
    BfmGroupDirective.prototype.errorContainerTemplate;
    /**
     * This defines the list of elements that BFM will monitor, identified by the
     * validation attributes (`required`, `min`, `max`, `minlength`, `maxlength`)
     * @type {?}
     */
    BfmGroupDirective.prototype.validations;
    /**
     * (default is `false`) Flag that validates form field only during focus out.
     * If set to true, BFM will not show error messages instantly as on when the
     * user is keying in the values.
     * @type {?}
     */
    BfmGroupDirective.prototype.validateOnBlurOnly;
    /**
     * (default is `false`) Set to `true` on a per-element basis to over ride
     * parent error template.
     * When to use: When a customized errorTemplate is used at the parent level
     * and if any group or field wants to use the default template
     * @type {?}
     */
    BfmGroupDirective.prototype.resetToDefaultErrorTemplate;
    /**
     * (default is `false`) Set to `true` on a per-element basis to over ride
     * parent error template.
     * When to use: When a customized errorContainerTemplate is used at the parent
     * level and if any group or field wants to use the default template
     * @type {?}
     */
    BfmGroupDirective.prototype.resetToDefaultErrorContainerTemplate;
    /**
     * A11y req: (default is `false`) Set to `true` on a per-element
     * basis to show field level error container (fieldLevelError) if
     * any explicit errorContainer is provided by the dev
     * @type {?}
     */
    BfmGroupDirective.prototype.showFieldLevelErrorContainer;
    /**
     * Flag to define whether this group is a parent of input elements whose type
     * is either `radio` or `checkbox`. By default it will be set to `false`.
     * @type {?}
     */
    BfmGroupDirective.prototype.options;
    /**
     * Callback function that will be called if the FormGroup entries are valid.
     * Devs can decide whether the group as a whole is valid or not based on their
     * business logic
     * @type {?}
     */
    BfmGroupDirective.prototype.groupValidate;
    /**
     * A11y req: (default is `false`) Set to `true` on a per-element basis to
     * show an error icon right next to each error field
     * @type {?}
     */
    BfmGroupDirective.prototype.showErrorIndicator;
    /**
     * (default is `false`) Flag to enable instant field validation as soon as the
     * user enters any value to the field. In other words when NgControl's `dirty`
     * property is set to true; irrespective of whether NgControl's `touched`
     * property is set to true or not.
     * @type {?}
     */
    BfmGroupDirective.prototype.instantValidation;
    /**
     * Flag to use the group level error container for all field errors that are
     * inside this group.
     * @type {?}
     */
    BfmGroupDirective.prototype.useErrorContainerForFieldErrors;
    /**
     * Error object used to add and remove error inside the error container
     * @type {?}
     */
    BfmGroupDirective.prototype.error;
    /** @type {?} */
    BfmGroupDirective.prototype.statusChangeSubscription;
    /** @type {?} */
    BfmGroupDirective.prototype.resetErrorsSubjectSubscription;
    /** @type {?} */
    BfmGroupDirective.prototype.controlContainer;
    /** @type {?} */
    BfmGroupDirective.prototype.parentForm;
    /** @type {?} */
    BfmGroupDirective.prototype.parentGroup;
    /** @type {?} */
    BfmGroupDirective.prototype.factoryResolver;
    /** @type {?} */
    BfmGroupDirective.prototype.el;
    /** @type {?} */
    BfmGroupDirective.prototype.utils;
    /** @type {?} */
    BfmGroupDirective.prototype.renderer;
    /** @type {?} */
    BfmGroupDirective.prototype.viewContainerRef;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * This directive is set on all input elements monitored by **BFM NG**. It adds
 * the following ARIA attributes for Accessibility compliance:
 *  - `aria-errormessage`
 *  - `aria-labelledby`
 *  - `aria-invalid`
 *  - `aria-required` (_only when the element is required_)
 *
 * If an element lacks a corresponding `<label>`, **BFM NG** will inject an
 * adjacent, hidden `<label>` with appropriate `for` and `aria-hidden`
 * attributes. This is screen reader Accessibility support.
 *
 * If a `<label>` is specified but the `for` value doesn't match the input
 * element's `id`, **BFM NG** will helpfully display a `$log.warn` console
 * message.
 */
var BfmFieldDirective = /** @class */ (function () {
    function BfmFieldDirective(control, el, factoryResolver, parentForm, parentGroup, renderer, utils, viewContainerRef, cd) {
        this.control = control;
        this.el = el;
        this.factoryResolver = factoryResolver;
        this.parentForm = parentForm;
        this.parentGroup = parentGroup;
        this.renderer = renderer;
        this.utils = utils;
        this.viewContainerRef = viewContainerRef;
        this.cd = cd;
        /**
         * Name of the element that will be used during error processing
         */
        this.name = '';
        /**
         * ID of the element that will be used during error processing
         */
        this.id = '';
        /**
         * Identifies from where the error originated - form/group/field
         */
        this.type = 'field';
        /**
         * Index of the error element in the same order as it the form fields
         * are rendered
         */
        this.errorElementIndex = -1;
        /**
         * A callback function allowing arbitrary error handling logic.
         * When to use: If you wish to manipulate other components in response to
         * errors; for example, to spawn a bento-alert.
         * How to override: Child elements of a parent configured to use
         * `error-handler` will inherit this behavior; to exempt any child element,
         * specify `error-handler=null` on the child.
         */
        this.errorHandler = new EventEmitter();
        /**
         * Callback function that will be called if the FormControl entry is valid.
         * Devs can decide whether this field is valid or not based on their business
         * logic
         */
        this.fieldValidate = new EventEmitter();
        /**
         * A11y req: Set to `true` on a per-element basis to mute the auto
         * generated label for that element if nothing is specified
         */
        this.muteAutoLabel = false;
        /**
         * When fieldValidate call back is called, set an error with the following
         * error key
         */
        this._customFieldValidate = 'CUSTOM-FIELD-VALIDATION-ERROR';
        this.valueChangesSubscription = Subscription.EMPTY;
        this.statusChangesSubscription = Subscription.EMPTY;
        this.formSubmittedSubjectSubscription = Subscription.EMPTY;
        this.resetErrorsSubjectSubscription = Subscription.EMPTY;
        this.error = null;
        this.flError = null;
        this.setAutoGenerateId = true;
        this.touched = false;
    }
    /**
     * During component initialization, BFM creates and inserts `error-container`
     * dynamically if `error-container` is not otherwise specified
     */
    /**
     * During component initialization, BFM creates and inserts `error-container`
     * dynamically if `error-container` is not otherwise specified
     * @return {?}
     */
    BfmFieldDirective.prototype.ngOnInit = /**
     * During component initialization, BFM creates and inserts `error-container`
     * dynamically if `error-container` is not otherwise specified
     * @return {?}
     */
    function () {
        var _this = this;
        this.valueChangesSubscription = this.control.valueChanges.subscribe(function (value) {
            /**
                   * if value is `null` or `undefined` -  means it's redefined or reset
                   * (by form - form.reset). remove errors if any
                   */
            if (!value) {
                _this.renderer.setAttribute(_this.el.nativeElement, 'aria-invalid', 'false');
                _this.renderer.removeClass(_this.el.nativeElement, 'bfm-invalid');
                // this.removeError();
                _this.touched = false;
            }
        });
        this.statusChangesSubscription = this.control.statusChanges.subscribe(function (status) {
            // In IE 11 this.control.touched property needs additional tick to be set
            setTimeout(function () {
                // check if there are any custom field errors, if present, do not
                // process the error as the error is already shown to the user
                var /** @type {?} */ doesHaveCustomFieldError = _this.checkForCustomFieldError();
                // show error once the control is touched
                // or there may be situations where dev's enable instantValidation
                var /** @type {?} */ canProcessError = _this.instantValidation ? _this.control.dirty : _this.control.touched;
                if (!doesHaveCustomFieldError && canProcessError && !_this.validateOnBlurOnly) {
                    // highlight the border in red - if any errors are found from error
                    // object
                    var /** @type {?} */ ehEvent = _this.processError();
                    if (!_this.validate(ehEvent)) {
                        // nothing to validate, handle the event
                        // show error message - if any errors are found from error object
                        _this.handleErrorHandlerEvent(ehEvent);
                    }
                    _this.cd.markForCheck();
                }
            });
        });
        this.touched = this.control.touched;
        this.validations =
            this.validations ||
                (this.parentGroup ? this.parentGroup.validations : undefined) ||
                this.parentForm.validations ||
                {};
        if (!this.resetToDefaultErrorTemplate) {
            if (this.parentGroup && this.parentGroup.resetToDefaultErrorTemplate) {
                this.errorTemplate = this.errorTemplate || (this.parentGroup && this.parentGroup.errorTemplate);
            }
            else {
                this.errorTemplate =
                    this.errorTemplate ||
                        (this.parentGroup && this.parentGroup.errorTemplate) ||
                        this.parentForm.errorTemplate ||
                        undefined;
            }
        }
        if (!this.resetToDefaultErrorContainerTemplate) {
            if (this.parentGroup && this.parentGroup.resetToDefaultErrorContainerTemplate) {
                this.errorContainerTemplate =
                    this.errorContainerTemplate || (this.parentGroup && this.parentGroup.errorContainerTemplate);
            }
            else {
                this.errorContainerTemplate =
                    this.errorContainerTemplate ||
                        (this.parentGroup && this.parentGroup.errorContainerTemplate) ||
                        this.parentForm.errorContainerTemplate ||
                        undefined;
            }
        }
        // FormGroup (BFMGroup) Logic: Use group error container only when
        // 'useErrorContainerForFieldErrors' is set to true
        var /** @type {?} */ groupErrorContainer = this.parentGroup && this.parentGroup.useErrorContainerForFieldErrors
            ? this.parentGroup.errorContainer
            : undefined;
        this.errorContainer = this.errorContainer || groupErrorContainer || this.parentForm.errorContainer;
        if (this.validateOnBlurOnly === undefined || this.validateOnBlurOnly === null) {
            this.validateOnBlurOnly =
                (this.parentGroup ? this.parentGroup.validateOnBlurOnly : false) || this.parentForm.validateOnBlurOnly || false;
        }
        if (this.instantValidation === undefined || this.instantValidation === null) {
            this.instantValidation =
                (this.parentGroup ? this.parentGroup.instantValidation : false) || this.parentForm.instantValidation || false;
        }
        /**
             * if `showFieldLevelErrorContainer` is defined at the field level, just
             * consume it, else if `showFieldLevelErrorContainer` is not defined at the
             * field level, then at the group level, or parent form level.
             */
        if (this.showFieldLevelErrorContainer === undefined) {
            if (this.parentGroup && this.parentGroup.showFieldLevelErrorContainer !== undefined) {
                this.showFieldLevelErrorContainer = this.parentGroup.showFieldLevelErrorContainer;
            }
            else if (this.parentForm.showFieldLevelErrorContainer !== undefined) {
                this.showFieldLevelErrorContainer = this.parentForm.showFieldLevelErrorContainer;
            }
        }
        var /** @type {?} */ type = this.el.nativeElement.getAttribute('type');
        // only for input whose type is NOT "checkbox"/"radio" and there is no
        // explicit error containers
        if (!this.errorContainer && type !== 'checkbox' && type !== 'radio') {
            var /** @type {?} */ factory = this.factoryResolver.resolveComponentFactory(BfmErrorContainerComponent);
            var /** @type {?} */ component = factory.create(this.viewContainerRef.parentInjector);
            this.viewContainerRef.insert(component.hostView);
            this.errorContainer = component.instance;
        }
        else if (this.showFieldLevelErrorContainer) {
            var /** @type {?} */ factory = this.factoryResolver.resolveComponentFactory(BfmErrorContainerComponent);
            var /** @type {?} */ component = factory.create(this.viewContainerRef.parentInjector);
            this.viewContainerRef.insert(component.hostView);
            this.fieldLevelError = component.instance;
        }
        if (this.errorContainerTemplate) {
            this.errorContainer.setErrorContainerTemplate(this.errorContainerTemplate);
        }
        /**
             * if `muteError` is defined at the field level, just consume it, else if
             * `muteError` is not defined at the field level, then at the group level,
             * or parent form level.
             */
        if (this.muteError === undefined) {
            if (this.parentGroup && this.parentGroup.muteError !== undefined) {
                this.muteError = this.parentGroup.muteError;
            }
            else if (this.parentForm.muteError !== undefined) {
                this.muteError = this.parentForm.muteError;
            }
        }
        /**
             * if `errorHandler` is defined at the field level, just consume it, else if
             * `errorHandler` is not defined at the field level, then at the group
             * level, or parent form level.
             */
        if (!this.errorHandler.observers.length) {
            delete this.errorHandler;
            if (this.parentGroup && this.parentGroup.errorHandler.observers.length) {
                this.errorHandler = this.parentGroup.errorHandler;
            }
            else if (this.parentForm.errorHandler.observers.length) {
                this.errorHandler = this.parentForm.errorHandler;
            }
        }
        /**
             * if `showErrorIndicator` is defined at the field level, just consume it,
             * else if `showErrorIndicator` is not defined at the field level, then at
             * the group level, or parent form level.
             */
        if (this.showErrorIndicator === undefined) {
            if (this.parentGroup && this.parentGroup.showErrorIndicator !== undefined) {
                this.showErrorIndicator = this.parentGroup.showErrorIndicator;
            }
            else if (this.parentForm.showErrorIndicator !== undefined) {
                this.showErrorIndicator = this.parentForm.showErrorIndicator;
            }
        }
        this.formSubmittedSubjectSubscription = this.parentForm.formSubmittedSubject.subscribe(function (submitted) {
            if (submitted) {
                var /** @type {?} */ ehEvent = _this.processError(true);
                if (!_this.validate(ehEvent)) {
                    _this.handleErrorHandlerEvent(ehEvent);
                }
            }
        });
        this.resetErrorsSubjectSubscription = this.parentForm.resetErrorsSubject.subscribe(function (reset) {
            if (reset) {
                _this.removeError();
                _this.removeErrorIndicator();
                // reset the error at the element level
                _this.renderer.setAttribute(_this.el.nativeElement, 'aria-invalid', 'false');
                _this.renderer.removeClass(_this.el.nativeElement, 'bfm-invalid');
            }
        });
    };
    /**
     * Once the component is initialized, BFM starts
     * 1. inspecting the field and sets `id`, `label` based on the need
     * 2. set aria attributes
     * 3. add sr-only error icon right next to the field
     */
    /**
     * Once the component is initialized, BFM starts
     * 1. inspecting the field and sets `id`, `label` based on the need
     * 2. set aria attributes
     * 3. add sr-only error icon right next to the field
     * @return {?}
     */
    BfmFieldDirective.prototype.ngAfterViewInit = /**
     * Once the component is initialized, BFM starts
     * 1. inspecting the field and sets `id`, `label` based on the need
     * 2. set aria attributes
     * 3. add sr-only error icon right next to the field
     * @return {?}
     */
    function () {
        !this.muteAutoLabel && this.setAutoGenerateId && this.setId(this.el.nativeElement);
        !this.muteAutoLabel &&
            this.setAutoGenerateId &&
            this.utils.addLabel(this.el.nativeElement, this.el.nativeElement.attributes, this.renderer);
        this.name = this.control.name;
        this.id = this.utils.getAttribute(this.el.nativeElement, 'id');
        // when setAutoGenerateId is set to false, id will be null on the element,
        // this is probably because some of the bento components
        // (bento-number-input, bentoSelect) will use the same id specified by the
        // devs
        if (!this.setAutoGenerateId) {
            var /** @type {?} */ inputEl = this.el.nativeElement.querySelector('input');
            this.id = inputEl && inputEl.getAttribute('id');
        }
        this.errorElementIndex = this.utils.getNewErrorIndex();
        this.fieldName = this.bfmLabel;
        if (!this.fieldName) {
            var /** @type {?} */ name_1 = this.el.nativeElement.getAttribute('name');
            var /** @type {?} */ fcn = this.el.nativeElement.getAttribute('formControlName');
            var /** @type {?} */ controlName = this.name;
            this.fieldName = this.utils.formatCamelCaseString(this.utils.UCFirst(name_1 || fcn || controlName));
        }
        this.renderer.setAttribute(this.el.nativeElement, 'aria-invalid', 'false');
        this.renderer.removeClass(this.el.nativeElement, 'bfm-invalid');
        // Create a container for input element
        if (this.showErrorIndicator) {
            var /** @type {?} */ type = this.el.nativeElement.getAttribute('type');
            var /** @type {?} */ tagName = this.el.nativeElement.tagName;
            // only for input NOT of type="checkbox"/"radio"
            if (type !== 'checkbox' && type !== 'radio') {
                var /** @type {?} */ inputContainerElement = this.renderer.createElement('span');
                this.renderer.addClass(inputContainerElement, 'input-group');
                this.errorIndicatorElement = this.renderer.createElement('i');
                this.errorIndicatorElement.classList.add('indicator-error-message');
                this.errorIndicatorElement.classList.add('bfm-sr-only');
                // width of the error icon is 20px + 1px border (during focus) + 2px
                // aligned towards right
                tagName === 'INPUT' && this.renderer.addClass(this.el.nativeElement, 'bfmfield-errorindicator');
                this.renderer.insertBefore(this.el.nativeElement.parentElement, inputContainerElement, this.el.nativeElement.nextElementSibling);
                this.renderer.appendChild(inputContainerElement, this.el.nativeElement);
                this.renderer.appendChild(inputContainerElement, this.errorIndicatorElement);
            }
        }
    };
    /**
     * Garbage cleaning
     */
    /**
     * Garbage cleaning
     * @return {?}
     */
    BfmFieldDirective.prototype.ngOnDestroy = /**
     * Garbage cleaning
     * @return {?}
     */
    function () {
        this.removeError();
        this.valueChangesSubscription.unsubscribe();
        this.statusChangesSubscription.unsubscribe();
        this.formSubmittedSubjectSubscription.unsubscribe();
        this.resetErrorsSubjectSubscription.unsubscribe();
    };
    /**
     * @return {?}
     */
    BfmFieldDirective.prototype.ngDoCheck = /**
     * @return {?}
     */
    function () {
        if (this.touched !== this.control.touched) {
            if ((this.touched = this.control.touched)) {
                // Check when get errors when control is touched
                this.checkAndHandleError();
            }
        }
    };
    /**
     * Event listener when BFM Field is blurred
     *
     * Using `focusout` to bring support to complex form elements
     *
     * @param {?} e
     * @return {?}
     */
    BfmFieldDirective.prototype.onFormElementBlur = /**
     * Event listener when BFM Field is blurred
     *
     * Using `focusout` to bring support to complex form elements
     *
     * @param {?} e
     * @return {?}
     */
    function (e) {
        var _this = this;
        if (this.validateOnBlurOnly) {
            setTimeout(function () {
                var /** @type {?} */ relatedEl = e.relatedTarget || document.activeElement;
                var /** @type {?} */ formElementEl = _this.el.nativeElement;
                if (relatedEl !== formElementEl && !formElementEl.contains(relatedEl)) {
                    // In IE 11 this.control.touched property needs additional tick to be set
                    // check if there are any custom field errors, if present, do not
                    // process the error as the error is already shown to the user
                    var /** @type {?} */ doesHaveCustomFieldError = _this.checkForCustomFieldError();
                    if (!doesHaveCustomFieldError) {
                        // The focus is on something that is not this element
                        // Do Check - element is blurred
                        _this.touched = _this.control.touched;
                        var /** @type {?} */ ehEvent = _this.processError(true);
                        if (!_this.validate(ehEvent)) {
                            // nothing to validate, handle the event
                            // show error message - if any errors are found from error object
                            _this.handleErrorHandlerEvent(ehEvent);
                        }
                        _this.cd.markForCheck();
                    }
                }
            });
        }
    };
    /**
     * @param {?} result
     * @return {?}
     */
    BfmFieldDirective.prototype.inspectForErrorFromForm = /**
     * @param {?} result
     * @return {?}
     */
    function (result) {
        return this.inspectForError(result, this.control.value);
    };
    /**
     * @param {?} result
     * @param {?} controlValue
     * @return {?}
     */
    BfmFieldDirective.prototype.inspectForError = /**
     * @param {?} result
     * @param {?} controlValue
     * @return {?}
     */
    function (result, controlValue) {
        // if the previous control value and new control values are not the
        // same, then the input value is altered by the user.
        // ignore any validation
        if (controlValue !== this.control.value) {
            return;
        }
        if (!result.valid) {
            // .errors will be present when the error is set using validators
            if (result.errors) {
                this.control.control.setErrors(result.errors);
            }
            else {
                if (this.error && this.error.message !== result.message) {
                    this.modifyError(result.message);
                }
                else if (!this.error) {
                    this.addError('', result.message || '__UNKNOWN_ERROR__');
                }
                this.setFieldError(result.message);
            }
            this.indicateError();
        }
        else {
            this.removeError();
        }
        this.cd.markForCheck();
    };
    /**
     * @return {?}
     */
    BfmFieldDirective.prototype.indicateError = /**
     * @return {?}
     */
    function () {
        this.renderer.setAttribute(this.el.nativeElement, 'aria-invalid', 'true');
        this.renderer.addClass(this.el.nativeElement, 'bfm-invalid');
        this.errorIndicatorElement && this.renderer.removeClass(this.errorIndicatorElement, 'bfm-sr-only');
    };
    /**
     * @return {?}
     */
    BfmFieldDirective.prototype.removeErrorIndicator = /**
     * @return {?}
     */
    function () {
        this.errorIndicatorElement && this.renderer.addClass(this.errorIndicatorElement, 'bfm-sr-only');
        this.errorIndicatorElement && this.renderer.setProperty(this.errorIndicatorElement, 'title', '');
    };
    /**
     * Check if this FormControl has an error and handle
     * @return {?}
     */
    BfmFieldDirective.prototype.checkAndHandleError = /**
     * Check if this FormControl has an error and handle
     * @return {?}
     */
    function () {
        // check if there are any custom field errors, if present, do not
        // process the error as the error is already shown to the user
        var /** @type {?} */ doesHaveCustomFieldError = this.checkForCustomFieldError();
        if (!doesHaveCustomFieldError) {
            // The focus is on something that is not this element
            // Do Check - element is blurred
            var /** @type {?} */ ehEvent = this.processError(true);
            if (!this.validate(ehEvent)) {
                // nothing to validate, handle the event
                // show error message - if any errors are found from error object
                this.handleErrorHandlerEvent(ehEvent);
            }
            this.cd.markForCheck();
        }
    };
    /**
     * Create and add an error to the error list
     * @param {?} type
     * @param {?} message
     * @return {?}
     */
    BfmFieldDirective.prototype.addError = /**
     * Create and add an error to the error list
     * @param {?} type
     * @param {?} message
     * @return {?}
     */
    function (type, message) {
        this.error = new BfmError(message, this.id, 'notify' + this.id, this.errorElementIndex, this.fieldName, {}, this.errorTemplate);
        this.errorContainer.addError(this.error);
        this.flError = new BfmError(message, this.id, 'notify' + this.id, this.errorElementIndex, this.fieldName, {});
        this.fieldLevelError && this.fieldLevelError.addError(this.flError);
    };
    /**
     * Set an ID to a given element
     * @param {?} element
     * @return {?}
     */
    BfmFieldDirective.prototype.setId = /**
     * Set an ID to a given element
     * @param {?} element
     * @return {?}
     */
    function (element) {
        var /** @type {?} */ idValue = this.utils.generateRandomId();
        // set `id` attribute, if not present - `setAttribute` won't add if `id`
        // value is already present
        this.utils.setProperty(element, 'id', idValue, false);
    };
    /**
     * Remove errors
     *
     * TODO: Are we removing all errors or simply pop the top one?
     * @return {?}
     */
    BfmFieldDirective.prototype.removeError = /**
     * Remove errors
     *
     * TODO: Are we removing all errors or simply pop the top one?
     * @return {?}
     */
    function () {
        if (this.error) {
            this.errorContainer.removeError(this.error);
            this.fieldLevelError && this.fieldLevelError.removeError(this.flError);
            delete this.error;
            delete this.flError && this.flError;
            this.error = null;
            this.flError = null;
        }
    };
    /**
     * Reuse the same bfm-error tag
     * @param {?} newErrorMessage New error message that must be shown
     * @return {?}
     */
    BfmFieldDirective.prototype.modifyError = /**
     * Reuse the same bfm-error tag
     * @param {?} newErrorMessage New error message that must be shown
     * @return {?}
     */
    function (newErrorMessage) {
        if (this.error) {
            this.errorContainer.modifyError(this.error, newErrorMessage);
            this.fieldLevelError && this.fieldLevelError.modifyError(this.flError, newErrorMessage);
        }
    };
    /**
     * Get an error message by its key
     * @param {?} key
     *
     * @return {?}
     */
    BfmFieldDirective.prototype.getErrorMessage = /**
     * Get an error message by its key
     * @param {?} key
     *
     * @return {?}
     */
    function (key) {
        var /** @type {?} */ errorMessage = '';
        if (this.validations[key]) {
            errorMessage = this.validations[key];
        }
        else if (this.parentGroup && this.parentGroup.validations && this.parentGroup.validations[key]) {
            return this.parentGroup.validations[key];
        }
        else if (this.parentForm && this.parentForm.validations && this.parentForm.validations[key]) {
            return this.parentForm.validations[key];
        }
        else if (this.utils.defaultValidationMessages[key]) {
            return this.utils.defaultValidationMessages[key];
        }
        else {
            return this.utils.defaultValidationMessages['unknown'];
        }
        return errorMessage;
    };
    /**
     * Get error key value by an error key
     * @param {?} errorKey
     *
     * @return {?}
     */
    BfmFieldDirective.prototype.getErrorKeyValue = /**
     * Get error key value by an error key
     * @param {?} errorKey
     *
     * @return {?}
     */
    function (errorKey) {
        var /** @type {?} */ errorValue = '';
        switch (errorKey) {
            case 'minlength':
            case 'maxlength':
            case 'min':
            case 'max':
                errorValue = this.control.errors[errorKey].requiredLength;
                break;
        }
        return errorValue;
    };
    /**
     * Process Error per each field
     * 1. Set field validity status
     * 2. Get the error message
     *
     * @param {?=} isFocusout Flag to decide whether to process error on that field,
     * irrespective of whether the control is touched or dirty
     *
     * @return {?} returns new error handler event
     */
    BfmFieldDirective.prototype.processError = /**
     * Process Error per each field
     * 1. Set field validity status
     * 2. Get the error message
     *
     * @param {?=} isFocusout Flag to decide whether to process error on that field,
     * irrespective of whether the control is touched or dirty
     *
     * @return {?} returns new error handler event
     */
    function (isFocusout) {
        var e_1, _a;
        var /** @type {?} */ errorMessage = '';
        var /** @type {?} */ isValid = false;
        var /** @type {?} */ errorObject = this.control.errors;
        if (isFocusout || this.control.touched || this.control.dirty) {
            if (!this.utils.isEmptyObject(errorObject)) {
                var /** @type {?} */ formControlName = void 0;
                this.indicateError();
                formControlName = this.bfmLabel;
                if (!formControlName) {
                    var /** @type {?} */ name_2 = this.el.nativeElement.getAttribute('name');
                    // TODO: Not sure if the following two are going be found since
                    // Angular remove NG
                    // TODO: attributes from its HTMLElements
                    // TODO: Need to rethink this logic here
                    var /** @type {?} */ model = this.el.nativeElement.getAttribute('ngModel');
                    var /** @type {?} */ fcn = this.el.nativeElement.getAttribute('formControlName');
                    formControlName = this.utils.formatCamelCaseString(this.utils.UCFirst(name_2 || model || fcn));
                }
                if (formControlName && formControlName.length) {
                    // look for 'name' attribute
                    var /** @type {?} */ errorKeys = Object.keys(errorObject); // fetch list of keys from errorObject
                    if (errorKeys) {
                        try {
                            for (var errorKeys_1 = __values(errorKeys), errorKeys_1_1 = errorKeys_1.next(); !errorKeys_1_1.done; errorKeys_1_1 = errorKeys_1.next()) {
                                var errorKey = errorKeys_1_1.value;
                                errorMessage = this.getErrorMessage(errorKey);
                                if (errorMessage.length) {
                                    var /** @type {?} */ attributeValue = this.getErrorKeyValue(errorKey);
                                    errorMessage = this.utils.formatValidationMessage(errorMessage, formControlName, attributeValue);
                                    // put the logic for mute-error, error-handler & error-template
                                    if (this.muteError) {
                                        break;
                                    }
                                    break; // show only 1 error, if found, break from the loop
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (errorKeys_1_1 && !errorKeys_1_1.done && (_a = errorKeys_1.return)) _a.call(errorKeys_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                    }
                    this.errorIndicatorElement && this.renderer.setProperty(this.errorIndicatorElement, 'title', errorMessage);
                }
            }
            else {
                isValid = true;
                this.renderer.setAttribute(this.el.nativeElement, 'aria-invalid', 'false');
                this.renderer.removeClass(this.el.nativeElement, 'bfm-invalid');
                this.errorIndicatorElement && this.renderer.addClass(this.errorIndicatorElement, 'bfm-sr-only');
                this.errorIndicatorElement && this.renderer.setProperty(this.errorIndicatorElement, 'title', '');
                this.removeError();
                if (this.errorHandler) {
                    this.errorHandler.emit(new BfmErrorHandlerEvent(isValid, errorMessage));
                }
            }
        }
        return new BfmErrorHandlerEvent(isValid, errorMessage);
    };
    /**
     * If the field is valid, callback dev's business logic to further validate
     * the entry
     * @param {?} ehEvent
     * @return {?}
     */
    BfmFieldDirective.prototype.validate = /**
     * If the field is valid, callback dev's business logic to further validate
     * the entry
     * @param {?} ehEvent
     * @return {?}
     */
    function (ehEvent) {
        var _this = this;
        if (ehEvent.valid && this.fieldValidate && this.fieldValidate.observers.length) {
            var /** @type {?} */ controlValue_1 = this.control.value;
            this.fieldValidate.emit(new BfmFieldEvent(this.control.control, function (result) {
                _this.inspectForError(result, controlValue_1);
            }));
            return true; // futher validation in process
        }
        return false; // nothing to validate, handle the event
    };
    /**
     * Based on `ehEvent` & `muteError`, this method will decide whether to add an
     * error or remove any existing error
     * @param {?} ehEvent - contains object of type `BfmErrorHandlerEvent`
     * @return {?}
     */
    BfmFieldDirective.prototype.handleErrorHandlerEvent = /**
     * Based on `ehEvent` & `muteError`, this method will decide whether to add an
     * error or remove any existing error
     * @param {?} ehEvent - contains object of type `BfmErrorHandlerEvent`
     * @return {?}
     */
    function (ehEvent) {
        if (!ehEvent.valid && !this.muteError) {
            // always show new error
            if (this.error && this.error.message !== ehEvent.message) {
                this.modifyError(ehEvent.message);
            }
            else if (!this.error) {
                this.addError('', ehEvent.message);
            }
        }
        else {
            this.removeError();
        }
        // put the logic for mute-error, error-handler & error-template
        if (this.errorHandler) {
            this.errorHandler.emit(ehEvent);
            this.cd.markForCheck();
        }
    };
    /**
     * @param {?} message
     * @return {?}
     */
    BfmFieldDirective.prototype.setFieldError = /**
     * @param {?} message
     * @return {?}
     */
    function (message) {
        var /** @type {?} */ name = this.control.name || 'Field';
        if (message) {
            var /** @type {?} */ errorObject = {};
            errorObject[this._customFieldValidate] = {};
            errorObject[this._customFieldValidate][name] = message;
            this.control.control.setErrors(errorObject);
        }
        else if (this.control.control.hasError(this._customFieldValidate)) {
            delete this.control.control.errors[this._customFieldValidate];
        }
    };
    /**
     * @return {?}
     */
    BfmFieldDirective.prototype.checkForCustomFieldError = /**
     * @return {?}
     */
    function () {
        var e_2, _a;
        var /** @type {?} */ errorPresent = false;
        var /** @type {?} */ errorObject = this.control.errors;
        var /** @type {?} */ errorKeys = errorObject && Object.keys(errorObject); // fetch list of keys from errorObject
        if (errorKeys) {
            try {
                for (var errorKeys_2 = __values(errorKeys), errorKeys_2_1 = errorKeys_2.next(); !errorKeys_2_1.done; errorKeys_2_1 = errorKeys_2.next()) {
                    var errorKey = errorKeys_2_1.value;
                    if (errorKey === this._customFieldValidate) {
                        errorPresent = true;
                        break;
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (errorKeys_2_1 && !errorKeys_2_1.done && (_a = errorKeys_2.return)) _a.call(errorKeys_2);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
        return errorPresent;
    };
    /** @nocollapse */
    BfmFieldDirective.ctorParameters = function () { return [
        { type: NgControl, },
        { type: ElementRef, },
        { type: ComponentFactoryResolver, },
        { type: BfmFormDirective, },
        { type: BfmGroupDirective, decorators: [{ type: Optional },] },
        { type: Renderer2, },
        { type: BfmUtilsService, },
        { type: ViewContainerRef, },
        { type: ChangeDetectorRef, },
    ]; };
    BfmFieldDirective.propDecorators = {
        "bfmLabel": [{ type: Input },],
        "validations": [{ type: Input },],
        "errorTemplate": [{ type: Input, args: ['errorTemplate',] },],
        "errorContainerTemplate": [{ type: Input, args: ['errorContainerTemplate',] },],
        "errorContainer": [{ type: Input },],
        "errorHandler": [{ type: Output },],
        "muteError": [{ type: Input },],
        "validateOnBlurOnly": [{ type: Input },],
        "resetToDefaultErrorTemplate": [{ type: Input },],
        "resetToDefaultErrorContainerTemplate": [{ type: Input },],
        "showFieldLevelErrorContainer": [{ type: Input },],
        "setAutoGenerateId": [{ type: Input },],
        "fieldValidate": [{ type: Output },],
        "showErrorIndicator": [{ type: Input },],
        "instantValidation": [{ type: Input },],
        "muteAutoLabel": [{ type: Input },],
        "onFormElementBlur": [{ type: HostListener, args: ['focusout', ['$event'],] },],
    };
BfmFieldDirective.ɵfac = function BfmFieldDirective_Factory(t) { return new (t || BfmFieldDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.NgControl), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(BfmFormDirective), ɵngcc0.ɵɵdirectiveInject(BfmGroupDirective, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(BfmUtilsService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
BfmFieldDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BfmFieldDirective, selectors: [["", "bfmField", ""]], hostBindings: function BfmFieldDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("focusout", function BfmFieldDirective_focusout_HostBindingHandler($event) { return ctx.onFormElementBlur($event); });
    } }, inputs: { muteAutoLabel: "muteAutoLabel", setAutoGenerateId: "setAutoGenerateId", validations: "validations", errorTemplate: "errorTemplate", errorContainerTemplate: "errorContainerTemplate", errorContainer: "errorContainer", validateOnBlurOnly: "validateOnBlurOnly", instantValidation: "instantValidation", showFieldLevelErrorContainer: "showFieldLevelErrorContainer", muteError: "muteError", showErrorIndicator: "showErrorIndicator", bfmLabel: "bfmLabel", resetToDefaultErrorTemplate: "resetToDefaultErrorTemplate", resetToDefaultErrorContainerTemplate: "resetToDefaultErrorContainerTemplate" }, outputs: { errorHandler: "errorHandler", fieldValidate: "fieldValidate" } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BfmFieldDirective, [{
        type: Directive,
        args: [{ selector: '[bfmField]' }]
    }], function () { return [{ type: ɵngcc2.NgControl }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.ComponentFactoryResolver }, { type: BfmFormDirective }, { type: BfmGroupDirective, decorators: [{
                type: Optional
            }] }, { type: ɵngcc0.Renderer2 }, { type: BfmUtilsService }, { type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.ChangeDetectorRef }]; }, { errorHandler: [{
            type: Output
        }], fieldValidate: [{
            type: Output
        }], muteAutoLabel: [{
            type: Input
        }], setAutoGenerateId: [{
            type: Input
        }], validations: [{
            type: Input
        }], errorTemplate: [{
            type: Input,
            args: ['errorTemplate']
        }], errorContainerTemplate: [{
            type: Input,
            args: ['errorContainerTemplate']
        }], errorContainer: [{
            type: Input
        }], validateOnBlurOnly: [{
            type: Input
        }], instantValidation: [{
            type: Input
        }], showFieldLevelErrorContainer: [{
            type: Input
        }], muteError: [{
            type: Input
        }], showErrorIndicator: [{
            type: Input
        }], onFormElementBlur: [{
            type: HostListener,
            args: ['focusout', ['$event']]
        }], bfmLabel: [{
            type: Input
        }], resetToDefaultErrorTemplate: [{
            type: Input
        }], resetToDefaultErrorContainerTemplate: [{
            type: Input
        }] }); })();
    return BfmFieldDirective;
}());
function BfmFieldDirective_tsickle_Closure_declarations() {
    /** @type {!Array<{type: !Function, args: (undefined|!Array<?>)}>} */
    BfmFieldDirective.decorators;
    /**
     * @nocollapse
     * @type {function(): !Array<(null|{type: ?, decorators: (undefined|!Array<{type: !Function, args: (undefined|!Array<?>)}>)})>}
     */
    BfmFieldDirective.ctorParameters;
    /** @type {!Object<string,!Array<{type: !Function, args: (undefined|!Array<?>)}>>} */
    BfmFieldDirective.propDecorators;
    /**
     * Name of the element that will be used during error processing
     * @type {?}
     */
    BfmFieldDirective.prototype.name;
    /**
     * ID of the element that will be used during error processing
     * @type {?}
     */
    BfmFieldDirective.prototype.id;
    /**
     * Identifies from where the error originated - form/group/field
     * @type {?}
     */
    BfmFieldDirective.prototype.type;
    /**
     * Index of the error element in the same order as it the form fields
     * are rendered
     * @type {?}
     */
    BfmFieldDirective.prototype.errorElementIndex;
    /**
     * Name of the form field - either value of bfmLabel or name/formControlName
     * attribute value
     * @type {?}
     */
    BfmFieldDirective.prototype.fieldName;
    /**
     * A11y improvement: Default error container placed right after each
     * form field. This will show up if dev specifies error container
     * (field/group/form level)l
     * @type {?}
     */
    BfmFieldDirective.prototype.fieldLevelError;
    /**
     * Label for the input element. BFM will use this label when showing errors
     * @type {?}
     */
    BfmFieldDirective.prototype.bfmLabel;
    /**
     * This defines the list of elements that BFM will monitor, identified by the
     * validation attributes (`required`, `min`, `max`, `minlength`, `maxlength`)
     * @type {?}
     */
    BfmFieldDirective.prototype.validations;
    /**
     * User defined error template, if provided. This is the default template
     * provided by **BFM NG** <br/>
     * `<ng-template #defaultErrorTemplate let-error="error"><span>{{
     * error.message }}</span></ng-template>`.<br/> Developers can override
     * default template using `errorTemplate`, with different template ID.
     * @type {?}
     */
    BfmFieldDirective.prototype.errorTemplate;
    /**
     * User defined error template to override the default error template. This
     * is the default template provided by **BFM NG**
     * <br/>
     * `<ng-template #defaultErrorContainerTemplate><bfm-error *ngFor="let e of
     * errors" [error]="e"></bfm-error> </ng-template>`.
     * @type {?}
     */
    BfmFieldDirective.prototype.errorContainerTemplate;
    /**
     * Defines the position where the error elements will be placed, if one is not
     * specified. They are rendered by default after each **BfmField**. This
     * can be customized at the field level also. To override the default
     * position, place the following template as per your UX demands. <br/>
     * `<bfm-error-container
     * #idToBeReferredByErrorContainer></bfm-error-container>`
     * @type {?}
     */
    BfmFieldDirective.prototype.errorContainer;
    /**
     * A callback function allowing arbitrary error handling logic.
     * When to use: If you wish to manipulate other components in response to
     * errors; for example, to spawn a bento-alert.
     * How to override: Child elements of a parent configured to use
     * `error-handler` will inherit this behavior; to exempt any child element,
     * specify `error-handler=null` on the child.
     * @type {?}
     */
    BfmFieldDirective.prototype.errorHandler;
    /**
     * (default is `false`) Set to `true` on a per-element basis to mute any error
     * reporting. When to use: If a customized `error-handler` is in use,
     * for example when calling a bento-alert, set this attribute to `true` to
     * mute default errors. By default it will be `false`.
     * @type {?}
     */
    BfmFieldDirective.prototype.muteError;
    /**
     * (default is `false`) Flag that validates form field only during focus out.
     * If set to true, BFM will not show error messages instantly as on when the
     * user is keying in the values.
     * @type {?}
     */
    BfmFieldDirective.prototype.validateOnBlurOnly;
    /**
     * (default is `false`) Set to `true` on a per-element basis to over ride
     * parent error template.
     * When to use: When a customized errorTemplate is used at the parent level
     * and if any group or field wants to use the default template
     * @type {?}
     */
    BfmFieldDirective.prototype.resetToDefaultErrorTemplate;
    /**
     * (default is `false`) Set to `true` on a per-element basis to over ride
     * parent error template.
     * When to use: When a customized errorContainerTemplate is used at the parent
     * level and if any group or field wants to use the default template
     * @type {?}
     */
    BfmFieldDirective.prototype.resetToDefaultErrorContainerTemplate;
    /**
     * A11y req: (default is `false`) Set to `true` on a per-element
     * basis to show field level error container (fieldLevelError) if
     * any explicit errorContainer is provided by the dev
     * @type {?}
     */
    BfmFieldDirective.prototype.showFieldLevelErrorContainer;
    /**
     * A11y req: (default is `true`) Set to `false` on a per-element
     * basis not to set the auto generated id for the element, as it's
     * taken care by the field itself (if the field is a complex component
     * by itself - Bento Component)
     * @type {?}
     */
    BfmFieldDirective.prototype.setAutoGenerateId;
    /**
     * Callback function that will be called if the FormControl entry is valid.
     * Devs can decide whether this field is valid or not based on their business
     * logic
     * @type {?}
     */
    BfmFieldDirective.prototype.fieldValidate;
    /**
     * A11y req: (default is `false`) Set to `true` on a per-element basis to
     * show an error icon right next to each error field
     * @type {?}
     */
    BfmFieldDirective.prototype.showErrorIndicator;
    /**
     * (default is `false`) Flag to enable instant field validation as soon as the
     * user enters any value to the field. In other words when NgControl's `dirty`
     * property is set to true; irrespective of whether NgControl's `touched`
     * property is set to true or not.
     * @type {?}
     */
    BfmFieldDirective.prototype.instantValidation;
    /**
     * A11y req: Set to `true` on a per-element basis to mute the auto
     * generated label for that element if nothing is specified
     * @type {?}
     */
    BfmFieldDirective.prototype.muteAutoLabel;
    /**
     * Internal member to keep track of touched state. Mainly used for the first
     * time. Once the element is blurred (for the first time), the value will be
     * set with the current touched state.
     * @type {?}
     */
    BfmFieldDirective.prototype.touched;
    /**
     * Error object used to add and remove error inside the error container
     * @type {?}
     */
    BfmFieldDirective.prototype.error;
    /**
     * Error object used to add and remove error inside the error container
     * @type {?}
     */
    BfmFieldDirective.prototype.flError;
    /**
     * A11y: Error icon that sits right next to input element, will be shown in
     * case of errors on the bfmField.
     * @type {?}
     */
    BfmFieldDirective.prototype.errorIndicatorElement;
    /**
     * When fieldValidate call back is called, set an error with the following
     * error key
     * @type {?}
     */
    BfmFieldDirective.prototype._customFieldValidate;
    /** @type {?} */
    BfmFieldDirective.prototype.valueChangesSubscription;
    /** @type {?} */
    BfmFieldDirective.prototype.statusChangesSubscription;
    /** @type {?} */
    BfmFieldDirective.prototype.formSubmittedSubjectSubscription;
    /** @type {?} */
    BfmFieldDirective.prototype.resetErrorsSubjectSubscription;
    /** @type {?} */
    BfmFieldDirective.prototype.control;
    /** @type {?} */
    BfmFieldDirective.prototype.el;
    /** @type {?} */
    BfmFieldDirective.prototype.factoryResolver;
    /** @type {?} */
    BfmFieldDirective.prototype.parentForm;
    /** @type {?} */
    BfmFieldDirective.prototype.parentGroup;
    /** @type {?} */
    BfmFieldDirective.prototype.renderer;
    /** @type {?} */
    BfmFieldDirective.prototype.utils;
    /** @type {?} */
    BfmFieldDirective.prototype.viewContainerRef;
    /** @type {?} */
    BfmFieldDirective.prototype.cd;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Bento FM NG Object
 */
var /** @type {?} */ BFM_NG_VERSION = new Version('2.2.3');
/**
 * Main BFM NG module declaration
 */
var BfmModule = /** @class */ (function () {
    function BfmModule() {
    }
BfmModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BfmModule });
BfmModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BfmModule_Factory(t) { return new (t || BfmModule)(); }, providers: [BfmUtilsService], imports: [[CommonModule, FormsModule, ReactiveFormsModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BfmModule, { declarations: function () { return [BfmErrorComponent,
        BfmErrorContainerComponent,
        BfmFormDirective,
        BfmFieldDirective,
        BfmGroupDirective,
        BfmErrorRenderDirective]; }, imports: function () { return [CommonModule, FormsModule, ReactiveFormsModule]; }, exports: function () { return [BfmErrorComponent,
        BfmErrorContainerComponent,
        BfmFieldDirective,
        BfmFormDirective,
        BfmGroupDirective,
        BfmErrorRenderDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BfmModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, FormsModule, ReactiveFormsModule],
                declarations: [
                    BfmErrorComponent,
                    BfmErrorContainerComponent,
                    BfmFormDirective,
                    BfmFieldDirective,
                    BfmGroupDirective,
                    BfmErrorRenderDirective
                ],
                exports: [
                    BfmErrorComponent,
                    BfmErrorContainerComponent,
                    BfmFieldDirective,
                    BfmFormDirective,
                    BfmGroupDirective,
                    BfmErrorRenderDirective
                ],
                providers: [BfmUtilsService],
                entryComponents: [BfmErrorContainerComponent]
            }]
    }], function () { return []; }, null); })();
    return BfmModule;
}());
function BfmModule_tsickle_Closure_declarations() {
    /** @type {!Array<{type: !Function, args: (undefined|!Array<?>)}>} */
    BfmModule.decorators;
    /**
     * @nocollapse
     * @type {function(): !Array<(null|{type: ?, decorators: (undefined|!Array<{type: !Function, args: (undefined|!Array<?>)}>)})>}
     */
    BfmModule.ctorParameters;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

export { BFM_NG_VERSION, BfmErrorComponent, BfmErrorContainerComponent, BfmErrorHandlerEvent, BfmFieldDirective, BfmFieldEvent, BfmFormDirective, BfmGroupDirective, BfmGroupEvent, BfmModule, BfmUtilsService, BfmErrorRenderDirective as ɵa, BfmValidityEvent as ɵb };

//# sourceMappingURL=bento-bfm-ng.js.map